//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { environment } from '@environments/environment';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export class BaseClient {
    constructor() {}

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected getBaseUrl(_: string, baseUrl?: string): string {
        return environment.apiUrl;
    }
}

export interface IAccountClient {
    /**
     * @return OK
     */
    accountGetById(id: number): Observable<AccountView>;
    /**
     * @return OK
     */
    accountGetBuildingProductTypes(id: number): Observable<BuildingProductTypeView[]>;
    /**
     * @return OK
     */
    accountSave(body: AccountView): Observable<AccountView>;
    /**
     * @return OK
     */
    accountActivate(id: number): Observable<void>;
    /**
     * @return OK
     */
    accountDeactivate(id: number): Observable<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    accountQuickSearch(body: QuickSearchAccountParameters | undefined): Observable<AccountView[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    accountSearch(body: SearchAccountParameters | undefined): Observable<AccountViewPaginatedResultDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    accountMapSearch(body: SearchAccountsMapParameters | undefined): Observable<AccountMapResult[]>;
}

@Injectable({ providedIn: 'root' })
export class AccountClient extends BaseClient implements IAccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    accountGetById(id: number): Observable<AccountView> {
        let url_ = this.baseUrl + "/api/Account/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountView>;
        }));
    }

    protected processAccountGetById(response: HttpResponseBase): Observable<AccountView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    accountGetBuildingProductTypes(id: number): Observable<BuildingProductTypeView[]> {
        let url_ = this.baseUrl + "/api/Account/{id}/building-product-types";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountGetBuildingProductTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountGetBuildingProductTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingProductTypeView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingProductTypeView[]>;
        }));
    }

    protected processAccountGetBuildingProductTypes(response: HttpResponseBase): Observable<BuildingProductTypeView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingProductTypeView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    accountSave(body: AccountView): Observable<AccountView> {
        let url_ = this.baseUrl + "/api/Account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountView>;
        }));
    }

    protected processAccountSave(response: HttpResponseBase): Observable<AccountView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    accountActivate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/activate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAccountActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    accountDeactivate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/deactivate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAccountDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    accountQuickSearch(body: QuickSearchAccountParameters | undefined): Observable<AccountView[]> {
        let url_ = this.baseUrl + "/api/Account/quick-search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountQuickSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountQuickSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountView[]>;
        }));
    }

    protected processAccountQuickSearch(response: HttpResponseBase): Observable<AccountView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    accountSearch(body: SearchAccountParameters | undefined): Observable<AccountViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/Account/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountViewPaginatedResultDto>;
        }));
    }

    protected processAccountSearch(response: HttpResponseBase): Observable<AccountViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    accountMapSearch(body: SearchAccountsMapParameters | undefined): Observable<AccountMapResult[]> {
        let url_ = this.baseUrl + "/api/Account/search-map";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountMapSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountMapSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountMapResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountMapResult[]>;
        }));
    }

    protected processAccountMapSearch(response: HttpResponseBase): Observable<AccountMapResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountMapResult[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAccountTypeClient {
    /**
     * @return OK
     */
    accountTypeGetAll(): Observable<AccountTypeView[]>;
}

@Injectable({ providedIn: 'root' })
export class AccountTypeClient extends BaseClient implements IAccountTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    accountTypeGetAll(): Observable<AccountTypeView[]> {
        let url_ = this.baseUrl + "/api/AccountType/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountTypeGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountTypeGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountTypeView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountTypeView[]>;
        }));
    }

    protected processAccountTypeGetAll(response: HttpResponseBase): Observable<AccountTypeView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountTypeView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IActivityLogClient {
    /**
     * @return OK
     */
    activityLogSearch(body: SearchActivityLogsParameters): Observable<ActivityLogViewPaginatedResultDto>;
    /**
     * @return OK
     */
    activityLogGetById(id: number): Observable<ActivityLogView>;
}

@Injectable({ providedIn: 'root' })
export class ActivityLogClient extends BaseClient implements IActivityLogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    activityLogSearch(body: SearchActivityLogsParameters): Observable<ActivityLogViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/ActivityLog/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivityLogSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivityLogSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityLogViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityLogViewPaginatedResultDto>;
        }));
    }

    protected processActivityLogSearch(response: HttpResponseBase): Observable<ActivityLogViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ActivityLogViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    activityLogGetById(id: number): Observable<ActivityLogView> {
        let url_ = this.baseUrl + "/api/ActivityLog/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivityLogGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivityLogGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityLogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityLogView>;
        }));
    }

    protected processActivityLogGetById(response: HttpResponseBase): Observable<ActivityLogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ActivityLogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAddressClient {
    /**
     * @param limit (optional) 
     * @return OK
     */
    addressSearchPlaces(query: string, limit: number | undefined): Observable<AddressView[]>;
    /**
     * @param zoomLevel (optional) 
     * @param width (optional) 
     * @param height (optional) 
     * @return OK
     */
    addressStaticImage(latitude: number, longitude: number, zoomLevel: number | undefined, width: number | undefined, height: number | undefined): Observable<string>;
    /**
     * @param zoomLevel (optional) 
     * @param width (optional) 
     * @param height (optional) 
     * @return OK
     */
    addressStaticImageById(id: number, zoomLevel: number | undefined, width: number | undefined, height: number | undefined): Observable<string>;
}

@Injectable({ providedIn: 'root' })
export class AddressClient extends BaseClient implements IAddressClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @param limit (optional) 
     * @return OK
     */
    addressSearchPlaces(query: string, limit: number | undefined): Observable<AddressView[]> {
        let url_ = this.baseUrl + "/api/Address/search?";
        if (query === undefined || query === null)
            throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressSearchPlaces(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressSearchPlaces(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressView[]>;
        }));
    }

    protected processAddressSearchPlaces(response: HttpResponseBase): Observable<AddressView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddressView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param zoomLevel (optional) 
     * @param width (optional) 
     * @param height (optional) 
     * @return OK
     */
    addressStaticImage(latitude: number, longitude: number, zoomLevel: number | undefined, width: number | undefined, height: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Address/static-image/{latitude}/{longitude}?";
        if (latitude === undefined || latitude === null)
            throw new globalThis.Error("The parameter 'latitude' must be defined.");
        url_ = url_.replace("{latitude}", encodeURIComponent("" + latitude));
        if (longitude === undefined || longitude === null)
            throw new globalThis.Error("The parameter 'longitude' must be defined.");
        url_ = url_.replace("{longitude}", encodeURIComponent("" + longitude));
        if (zoomLevel === null)
            throw new globalThis.Error("The parameter 'zoomLevel' cannot be null.");
        else if (zoomLevel !== undefined)
            url_ += "zoomLevel=" + encodeURIComponent("" + zoomLevel) + "&";
        if (width === null)
            throw new globalThis.Error("The parameter 'width' cannot be null.");
        else if (width !== undefined)
            url_ += "width=" + encodeURIComponent("" + width) + "&";
        if (height === null)
            throw new globalThis.Error("The parameter 'height' cannot be null.");
        else if (height !== undefined)
            url_ += "height=" + encodeURIComponent("" + height) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressStaticImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressStaticImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddressStaticImage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : _responseText as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param zoomLevel (optional) 
     * @param width (optional) 
     * @param height (optional) 
     * @return OK
     */
    addressStaticImageById(id: number, zoomLevel: number | undefined, width: number | undefined, height: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Address/address-static-image/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (zoomLevel === null)
            throw new globalThis.Error("The parameter 'zoomLevel' cannot be null.");
        else if (zoomLevel !== undefined)
            url_ += "zoomLevel=" + encodeURIComponent("" + zoomLevel) + "&";
        if (width === null)
            throw new globalThis.Error("The parameter 'width' cannot be null.");
        else if (width !== undefined)
            url_ += "width=" + encodeURIComponent("" + width) + "&";
        if (height === null)
            throw new globalThis.Error("The parameter 'height' cannot be null.");
        else if (height !== undefined)
            url_ += "height=" + encodeURIComponent("" + height) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressStaticImageById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressStaticImageById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddressStaticImageById(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : _responseText as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IArchiveEntityClient {
    /**
     * @return OK
     */
    archiveEntityGetArchiveOptions(): Observable<ArchiveEntityOptionView[]>;
}

@Injectable({ providedIn: 'root' })
export class ArchiveEntityClient extends BaseClient implements IArchiveEntityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    archiveEntityGetArchiveOptions(): Observable<ArchiveEntityOptionView[]> {
        let url_ = this.baseUrl + "/api/ArchiveEntity/options";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveEntityGetArchiveOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveEntityGetArchiveOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArchiveEntityOptionView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArchiveEntityOptionView[]>;
        }));
    }

    protected processArchiveEntityGetArchiveOptions(response: HttpResponseBase): Observable<ArchiveEntityOptionView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ArchiveEntityOptionView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBidCategoryClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    bidCategoryQuickSearch(body: QuickSearchBidCategoriesParameters | undefined): Observable<BidCategoryView[]>;
}

@Injectable({ providedIn: 'root' })
export class BidCategoryClient extends BaseClient implements IBidCategoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bidCategoryQuickSearch(body: QuickSearchBidCategoriesParameters | undefined): Observable<BidCategoryView[]> {
        let url_ = this.baseUrl + "/api/BidCategory/quick-search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBidCategoryQuickSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBidCategoryQuickSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BidCategoryView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BidCategoryView[]>;
        }));
    }

    protected processBidCategoryQuickSearch(response: HttpResponseBase): Observable<BidCategoryView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BidCategoryView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBuildingClient {
    /**
     * @return OK
     */
    buildingGetById(id: number): Observable<BuildingView>;
    /**
     * @return OK
     */
    buildingSave(body: BuildingView): Observable<BuildingView>;
    /**
     * @param body (optional) 
     * @return OK
     */
    buildingSearch(body: SearchBuildingsParameters | undefined): Observable<BuildingViewPaginatedResultDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    buildingSearchForContact(body: SearchBuildingsForContactParameters | undefined): Observable<BuildingContactViewPaginatedResultDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    buildingSearchForCompany(body: SearchBuildingsForCompanyParameters | undefined): Observable<CompanyBuildingViewPaginatedResultDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    buildingSearchForAccount(body: SearchBuildingsForAccountParameters | undefined): Observable<CompanyBuildingViewPaginatedResultDto>;
    /**
     * @return OK
     */
    buildingSearchAvailableCompanies(body: SearchAvailableBuildingCompaniesParameters): Observable<CompanyView[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    buildingQuickSearch(body: QuickSearchBuildingParameters | undefined): Observable<BuildingView[]>;
    /**
     * @return OK
     */
    buildingActivate(id: number): Observable<void>;
    /**
     * @return OK
     */
    buildingDeactivate(id: number): Observable<void>;
    /**
     * @param body (optional) 
     * @return OK
     */
    buildingMapSearch(body: SearchBuildingsMapParameters | undefined): Observable<BuildingMapResult[]>;
}

@Injectable({ providedIn: 'root' })
export class BuildingClient extends BaseClient implements IBuildingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    buildingGetById(id: number): Observable<BuildingView> {
        let url_ = this.baseUrl + "/api/Building/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingView>;
        }));
    }

    protected processBuildingGetById(response: HttpResponseBase): Observable<BuildingView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    buildingSave(body: BuildingView): Observable<BuildingView> {
        let url_ = this.baseUrl + "/api/Building";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingView>;
        }));
    }

    protected processBuildingSave(response: HttpResponseBase): Observable<BuildingView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    buildingSearch(body: SearchBuildingsParameters | undefined): Observable<BuildingViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/Building/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingViewPaginatedResultDto>;
        }));
    }

    protected processBuildingSearch(response: HttpResponseBase): Observable<BuildingViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    buildingSearchForContact(body: SearchBuildingsForContactParameters | undefined): Observable<BuildingContactViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/Building/search-for-contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingSearchForContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingSearchForContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingContactViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingContactViewPaginatedResultDto>;
        }));
    }

    protected processBuildingSearchForContact(response: HttpResponseBase): Observable<BuildingContactViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingContactViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    buildingSearchForCompany(body: SearchBuildingsForCompanyParameters | undefined): Observable<CompanyBuildingViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/Building/search-for-company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingSearchForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingSearchForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyBuildingViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyBuildingViewPaginatedResultDto>;
        }));
    }

    protected processBuildingSearchForCompany(response: HttpResponseBase): Observable<CompanyBuildingViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyBuildingViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    buildingSearchForAccount(body: SearchBuildingsForAccountParameters | undefined): Observable<CompanyBuildingViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/Building/search-for-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingSearchForAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingSearchForAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyBuildingViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyBuildingViewPaginatedResultDto>;
        }));
    }

    protected processBuildingSearchForAccount(response: HttpResponseBase): Observable<CompanyBuildingViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyBuildingViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    buildingSearchAvailableCompanies(body: SearchAvailableBuildingCompaniesParameters): Observable<CompanyView[]> {
        let url_ = this.baseUrl + "/api/Building/search-available-companies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingSearchAvailableCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingSearchAvailableCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyView[]>;
        }));
    }

    protected processBuildingSearchAvailableCompanies(response: HttpResponseBase): Observable<CompanyView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    buildingQuickSearch(body: QuickSearchBuildingParameters | undefined): Observable<BuildingView[]> {
        let url_ = this.baseUrl + "/api/Building/quick-search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingQuickSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingQuickSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingView[]>;
        }));
    }

    protected processBuildingQuickSearch(response: HttpResponseBase): Observable<BuildingView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    buildingActivate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Building/activate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBuildingActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    buildingDeactivate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Building/deactivate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBuildingDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    buildingMapSearch(body: SearchBuildingsMapParameters | undefined): Observable<BuildingMapResult[]> {
        let url_ = this.baseUrl + "/api/Building/search-map";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingMapSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingMapSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingMapResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingMapResult[]>;
        }));
    }

    protected processBuildingMapSearch(response: HttpResponseBase): Observable<BuildingMapResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingMapResult[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBuildingClassClient {
    /**
     * @return OK
     */
    buildingClassGetAll(): Observable<BuildingClassView[]>;
}

@Injectable({ providedIn: 'root' })
export class BuildingClassClient extends BaseClient implements IBuildingClassClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    buildingClassGetAll(): Observable<BuildingClassView[]> {
        let url_ = this.baseUrl + "/api/BuildingClass/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingClassGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingClassGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingClassView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingClassView[]>;
        }));
    }

    protected processBuildingClassGetAll(response: HttpResponseBase): Observable<BuildingClassView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingClassView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBuildingContactClient {
    /**
     * @return OK
     */
    buildingContactSearchAvailable(body: SearchAvailableBuildingContactsParameters): Observable<ContactView[]>;
    /**
     * @return OK
     */
    buildingContactUpdateContactCompany(id: number): Observable<BuildingContactView>;
    /**
     * @return OK
     */
    buildingContactSaveContact(body: BuildingContactView): Observable<BuildingContactView>;
    /**
     * @return OK
     */
    buildingContactRemoveContact(body: BuildingContactView): Observable<void>;
}

@Injectable({ providedIn: 'root' })
export class BuildingContactClient extends BaseClient implements IBuildingContactClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    buildingContactSearchAvailable(body: SearchAvailableBuildingContactsParameters): Observable<ContactView[]> {
        let url_ = this.baseUrl + "/api/BuildingContact/search-available-building-contacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingContactSearchAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingContactSearchAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactView[]>;
        }));
    }

    protected processBuildingContactSearchAvailable(response: HttpResponseBase): Observable<ContactView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    buildingContactUpdateContactCompany(id: number): Observable<BuildingContactView> {
        let url_ = this.baseUrl + "/api/BuildingContact/update-company/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingContactUpdateContactCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingContactUpdateContactCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingContactView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingContactView>;
        }));
    }

    protected processBuildingContactUpdateContactCompany(response: HttpResponseBase): Observable<BuildingContactView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingContactView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    buildingContactSaveContact(body: BuildingContactView): Observable<BuildingContactView> {
        let url_ = this.baseUrl + "/api/BuildingContact/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingContactSaveContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingContactSaveContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingContactView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingContactView>;
        }));
    }

    protected processBuildingContactSaveContact(response: HttpResponseBase): Observable<BuildingContactView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingContactView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    buildingContactRemoveContact(body: BuildingContactView): Observable<void> {
        let url_ = this.baseUrl + "/api/BuildingContact/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingContactRemoveContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingContactRemoveContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBuildingContactRemoveContact(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBuildingContactRoleClient {
    /**
     * @return OK
     */
    buildingContactRoleGetById(id: number): Observable<BuildingContactRoleView>;
    /**
     * @param filterText (optional) 
     * @return OK
     */
    buildingContactRoleGetByUsage(entityTypeId: number, filterText: string | undefined): Observable<BuildingContactRoleView[]>;
}

@Injectable({ providedIn: 'root' })
export class BuildingContactRoleClient extends BaseClient implements IBuildingContactRoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    buildingContactRoleGetById(id: number): Observable<BuildingContactRoleView> {
        let url_ = this.baseUrl + "/api/BuildingContactRole/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingContactRoleGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingContactRoleGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingContactRoleView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingContactRoleView>;
        }));
    }

    protected processBuildingContactRoleGetById(response: HttpResponseBase): Observable<BuildingContactRoleView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingContactRoleView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filterText (optional) 
     * @return OK
     */
    buildingContactRoleGetByUsage(entityTypeId: number, filterText: string | undefined): Observable<BuildingContactRoleView[]> {
        let url_ = this.baseUrl + "/api/BuildingContactRole/by-usage/{entityTypeId}?";
        if (entityTypeId === undefined || entityTypeId === null)
            throw new globalThis.Error("The parameter 'entityTypeId' must be defined.");
        url_ = url_.replace("{entityTypeId}", encodeURIComponent("" + entityTypeId));
        if (filterText === null)
            throw new globalThis.Error("The parameter 'filterText' cannot be null.");
        else if (filterText !== undefined)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuildingContactRoleGetByUsage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildingContactRoleGetByUsage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingContactRoleView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingContactRoleView[]>;
        }));
    }

    protected processBuildingContactRoleGetByUsage(response: HttpResponseBase): Observable<BuildingContactRoleView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingContactRoleView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICityClient {
    /**
     * @return OK
     */
    cityGetById(id: number): Observable<CityView>;
    /**
     * @return OK
     */
    citySearch(body: SearchCityParameters): Observable<CityView[]>;
}

@Injectable({ providedIn: 'root' })
export class CityClient extends BaseClient implements ICityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    cityGetById(id: number): Observable<CityView> {
        let url_ = this.baseUrl + "/api/City/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCityGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCityGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CityView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CityView>;
        }));
    }

    protected processCityGetById(response: HttpResponseBase): Observable<CityView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CityView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    citySearch(body: SearchCityParameters): Observable<CityView[]> {
        let url_ = this.baseUrl + "/api/City/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCitySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCitySearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CityView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CityView[]>;
        }));
    }

    protected processCitySearch(response: HttpResponseBase): Observable<CityView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CityView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompanyClient {
    /**
     * @return OK
     */
    companyGetById(id: number): Observable<CompanyView>;
    /**
     * @return OK
     */
    companySave(body: CompanyView): Observable<CompanyView>;
    /**
     * @param body (optional) 
     * @return OK
     */
    companySearch(body: SearchCompaniesParameters | undefined): Observable<CompanyViewPaginatedResultDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    companySearchCompaniesForBuilding(body: SearchCompaniesForBuildingParameters | undefined): Observable<CompanyBuildingViewPaginatedResultDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    companySearchCompaniesForAccount(body: SearchCompaniesForAccountParameters | undefined): Observable<CompanyViewPaginatedResultDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    companyQuickSearch(body: QuickSearchCompaniesParameters | undefined): Observable<CompanyView[]>;
    /**
     * @return OK
     */
    companyActivate(id: number): Observable<void>;
    /**
     * @return OK
     */
    companyDeactivate(id: number): Observable<void>;
    /**
     * @return OK
     */
    companySearchAvailableBuildings(body: SearchAvailableCompanyBuildingsParameters): Observable<BuildingView[]>;
    /**
     * @return OK
     */
    companySearchAvailableAccountCompanies(body: SearchAvailableAccountCompaniesParameters): Observable<CompanyView[]>;
    /**
     * @return OK
     */
    companyRemoveAccount(id: number): Observable<void>;
    /**
     * @return OK
     */
    companySetAccount(body: SaveAccountParameters): Observable<CompanyView>;
    /**
     * @param body (optional) 
     * @return OK
     */
    companyMapSearch(body: SearchCompaniesMapParameters | undefined): Observable<CompanyMapResult[]>;
}

@Injectable({ providedIn: 'root' })
export class CompanyClient extends BaseClient implements ICompanyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    companyGetById(id: number): Observable<CompanyView> {
        let url_ = this.baseUrl + "/api/Company/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyView>;
        }));
    }

    protected processCompanyGetById(response: HttpResponseBase): Observable<CompanyView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companySave(body: CompanyView): Observable<CompanyView> {
        let url_ = this.baseUrl + "/api/Company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanySave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanySave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyView>;
        }));
    }

    protected processCompanySave(response: HttpResponseBase): Observable<CompanyView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    companySearch(body: SearchCompaniesParameters | undefined): Observable<CompanyViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/Company/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanySearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyViewPaginatedResultDto>;
        }));
    }

    protected processCompanySearch(response: HttpResponseBase): Observable<CompanyViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    companySearchCompaniesForBuilding(body: SearchCompaniesForBuildingParameters | undefined): Observable<CompanyBuildingViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/Company/search-for-buildings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanySearchCompaniesForBuilding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanySearchCompaniesForBuilding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyBuildingViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyBuildingViewPaginatedResultDto>;
        }));
    }

    protected processCompanySearchCompaniesForBuilding(response: HttpResponseBase): Observable<CompanyBuildingViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyBuildingViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    companySearchCompaniesForAccount(body: SearchCompaniesForAccountParameters | undefined): Observable<CompanyViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/Company/search-for-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanySearchCompaniesForAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanySearchCompaniesForAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyViewPaginatedResultDto>;
        }));
    }

    protected processCompanySearchCompaniesForAccount(response: HttpResponseBase): Observable<CompanyViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    companyQuickSearch(body: QuickSearchCompaniesParameters | undefined): Observable<CompanyView[]> {
        let url_ = this.baseUrl + "/api/Company/quick-search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyQuickSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyQuickSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyView[]>;
        }));
    }

    protected processCompanyQuickSearch(response: HttpResponseBase): Observable<CompanyView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companyActivate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Company/activate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompanyActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companyDeactivate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Company/deactivate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompanyDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companySearchAvailableBuildings(body: SearchAvailableCompanyBuildingsParameters): Observable<BuildingView[]> {
        let url_ = this.baseUrl + "/api/Company/search-available-buildings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanySearchAvailableBuildings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanySearchAvailableBuildings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingView[]>;
        }));
    }

    protected processCompanySearchAvailableBuildings(response: HttpResponseBase): Observable<BuildingView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companySearchAvailableAccountCompanies(body: SearchAvailableAccountCompaniesParameters): Observable<CompanyView[]> {
        let url_ = this.baseUrl + "/api/Company/search-available-companies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanySearchAvailableAccountCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanySearchAvailableAccountCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyView[]>;
        }));
    }

    protected processCompanySearchAvailableAccountCompanies(response: HttpResponseBase): Observable<CompanyView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companyRemoveAccount(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Company/remove-account/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyRemoveAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyRemoveAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompanyRemoveAccount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companySetAccount(body: SaveAccountParameters): Observable<CompanyView> {
        let url_ = this.baseUrl + "/api/Company/set-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanySetAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanySetAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyView>;
        }));
    }

    protected processCompanySetAccount(response: HttpResponseBase): Observable<CompanyView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    companyMapSearch(body: SearchCompaniesMapParameters | undefined): Observable<CompanyMapResult[]> {
        let url_ = this.baseUrl + "/api/Company/search-map";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyMapSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyMapSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyMapResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyMapResult[]>;
        }));
    }

    protected processCompanyMapSearch(response: HttpResponseBase): Observable<CompanyMapResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyMapResult[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompanyBuildingClient {
    /**
     * @return OK
     */
    companyBuildingSave(body: CompanyBuildingView): Observable<CompanyBuildingView>;
    /**
     * @return OK
     */
    companyBuildingSetBuildingAsMain(body: CompanyBuildingView): Observable<void>;
    /**
     * @return OK
     */
    companyBuildingUnsetAsMain(body: CompanyBuildingView): Observable<void>;
    /**
     * @return OK
     */
    companyBuildingRemoveCompanyBuilding(body: CompanyBuildingView): Observable<void>;
}

@Injectable({ providedIn: 'root' })
export class CompanyBuildingClient extends BaseClient implements ICompanyBuildingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    companyBuildingSave(body: CompanyBuildingView): Observable<CompanyBuildingView> {
        let url_ = this.baseUrl + "/api/CompanyBuilding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyBuildingSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyBuildingSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyBuildingView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyBuildingView>;
        }));
    }

    protected processCompanyBuildingSave(response: HttpResponseBase): Observable<CompanyBuildingView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyBuildingView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companyBuildingSetBuildingAsMain(body: CompanyBuildingView): Observable<void> {
        let url_ = this.baseUrl + "/api/CompanyBuilding/set-as-main";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyBuildingSetBuildingAsMain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyBuildingSetBuildingAsMain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompanyBuildingSetBuildingAsMain(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companyBuildingUnsetAsMain(body: CompanyBuildingView): Observable<void> {
        let url_ = this.baseUrl + "/api/CompanyBuilding/unset-as-main";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyBuildingUnsetAsMain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyBuildingUnsetAsMain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompanyBuildingUnsetAsMain(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    companyBuildingRemoveCompanyBuilding(body: CompanyBuildingView): Observable<void> {
        let url_ = this.baseUrl + "/api/CompanyBuilding/remove-company-buiding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyBuildingRemoveCompanyBuilding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyBuildingRemoveCompanyBuilding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompanyBuildingRemoveCompanyBuilding(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICompanyTypeClient {
    /**
     * @return OK
     */
    companyTypeGetAll(): Observable<CompanyTypeView[]>;
}

@Injectable({ providedIn: 'root' })
export class CompanyTypeClient extends BaseClient implements ICompanyTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    companyTypeGetAll(): Observable<CompanyTypeView[]> {
        let url_ = this.baseUrl + "/api/CompanyType/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyTypeGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyTypeGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyTypeView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyTypeView[]>;
        }));
    }

    protected processCompanyTypeGetAll(response: HttpResponseBase): Observable<CompanyTypeView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyTypeView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IConfigurationClient {
    /**
     * @return OK
     */
    configurationGetMapConfiguration(): Observable<MapClientConfiguration>;
    /**
     * @return OK
     */
    configurationGetConfigurationEntries(): Observable<ConfigurationEntry[]>;
}

@Injectable({ providedIn: 'root' })
export class ConfigurationClient extends BaseClient implements IConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    configurationGetMapConfiguration(): Observable<MapClientConfiguration> {
        let url_ = this.baseUrl + "/api/Configuration/map";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfigurationGetMapConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfigurationGetMapConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MapClientConfiguration>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MapClientConfiguration>;
        }));
    }

    protected processConfigurationGetMapConfiguration(response: HttpResponseBase): Observable<MapClientConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MapClientConfiguration;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    configurationGetConfigurationEntries(): Observable<ConfigurationEntry[]> {
        let url_ = this.baseUrl + "/api/Configuration/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfigurationGetConfigurationEntries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfigurationGetConfigurationEntries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationEntry[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationEntry[]>;
        }));
    }

    protected processConfigurationGetConfigurationEntries(response: HttpResponseBase): Observable<ConfigurationEntry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConfigurationEntry[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IContactClient {
    /**
     * @return OK
     */
    contactGetById(id: number): Observable<ContactView>;
    /**
     * @return OK
     */
    contactSave(body: ContactView): Observable<ContactView>;
    /**
     * @param body (optional) 
     * @return OK
     */
    contactSearch(body: SearchContactsParameters | undefined): Observable<ContactViewPaginatedResultDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    contactSearchForBuilding(body: SearchContactsForBuildingParameters | undefined): Observable<BuildingContactViewPaginatedResultDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    contactSearchForCompany(body: SearchContactsForCompanyParameters | undefined): Observable<ContactViewPaginatedResultDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    contactSearchForAccount(body: SearchContactsForAccountParameters | undefined): Observable<ContactViewPaginatedResultDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    contactQuickSearch(body: QuickSearchContactsParameters | undefined): Observable<ContactView[]>;
    /**
     * @return OK
     */
    contactActivate(id: number): Observable<void>;
    /**
     * @return OK
     */
    contactDeactivate(id: number): Observable<void>;
    /**
     * @return OK
     */
    contactSetAsMain(id: number): Observable<void>;
    /**
     * @return OK
     */
    contactUnsetAsMain(id: number): Observable<void>;
    /**
     * @return OK
     */
    contactSearchAvailableBuildings(body: SearchAvailableContactBuildingsParameters): Observable<BuildingView[]>;
}

@Injectable({ providedIn: 'root' })
export class ContactClient extends BaseClient implements IContactClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    contactGetById(id: number): Observable<ContactView> {
        let url_ = this.baseUrl + "/api/Contact/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactView>;
        }));
    }

    protected processContactGetById(response: HttpResponseBase): Observable<ContactView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    contactSave(body: ContactView): Observable<ContactView> {
        let url_ = this.baseUrl + "/api/Contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactView>;
        }));
    }

    protected processContactSave(response: HttpResponseBase): Observable<ContactView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    contactSearch(body: SearchContactsParameters | undefined): Observable<ContactViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/Contact/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactViewPaginatedResultDto>;
        }));
    }

    protected processContactSearch(response: HttpResponseBase): Observable<ContactViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    contactSearchForBuilding(body: SearchContactsForBuildingParameters | undefined): Observable<BuildingContactViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/Contact/search-for-building";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactSearchForBuilding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactSearchForBuilding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingContactViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingContactViewPaginatedResultDto>;
        }));
    }

    protected processContactSearchForBuilding(response: HttpResponseBase): Observable<BuildingContactViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingContactViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    contactSearchForCompany(body: SearchContactsForCompanyParameters | undefined): Observable<ContactViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/Contact/search-for-company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactSearchForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactSearchForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactViewPaginatedResultDto>;
        }));
    }

    protected processContactSearchForCompany(response: HttpResponseBase): Observable<ContactViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    contactSearchForAccount(body: SearchContactsForAccountParameters | undefined): Observable<ContactViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/Contact/search-for-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactSearchForAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactSearchForAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactViewPaginatedResultDto>;
        }));
    }

    protected processContactSearchForAccount(response: HttpResponseBase): Observable<ContactViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    contactQuickSearch(body: QuickSearchContactsParameters | undefined): Observable<ContactView[]> {
        let url_ = this.baseUrl + "/api/Contact/quick-search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactQuickSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactQuickSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactView[]>;
        }));
    }

    protected processContactQuickSearch(response: HttpResponseBase): Observable<ContactView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    contactActivate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Contact/activate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processContactActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    contactDeactivate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Contact/deactivate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processContactDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    contactSetAsMain(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Contact/set-as-main/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactSetAsMain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactSetAsMain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processContactSetAsMain(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    contactUnsetAsMain(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Contact/unset-as-main/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactUnsetAsMain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactUnsetAsMain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processContactUnsetAsMain(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    contactSearchAvailableBuildings(body: SearchAvailableContactBuildingsParameters): Observable<BuildingView[]> {
        let url_ = this.baseUrl + "/api/Contact/search-avaliable-buildings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactSearchAvailableBuildings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactSearchAvailableBuildings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingView[]>;
        }));
    }

    protected processContactSearchAvailableBuildings(response: HttpResponseBase): Observable<BuildingView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICountryClient {
    /**
     * @return OK
     */
    countryGetById(id: number): Observable<CountryView>;
    /**
     * @return OK
     */
    countrySearch(body: SearchCountryParameters): Observable<CountryView[]>;
}

@Injectable({ providedIn: 'root' })
export class CountryClient extends BaseClient implements ICountryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    countryGetById(id: number): Observable<CountryView> {
        let url_ = this.baseUrl + "/api/Country/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountryGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountryGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryView>;
        }));
    }

    protected processCountryGetById(response: HttpResponseBase): Observable<CountryView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountryView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    countrySearch(body: SearchCountryParameters): Observable<CountryView[]> {
        let url_ = this.baseUrl + "/api/Country/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountrySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountrySearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryView[]>;
        }));
    }

    protected processCountrySearch(response: HttpResponseBase): Observable<CountryView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountryView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICustomFieldTypeClient {
    /**
     * @return OK
     */
    customFieldTypeGetAll(): Observable<CustomFieldTypeView[]>;
}

@Injectable({ providedIn: 'root' })
export class CustomFieldTypeClient extends BaseClient implements ICustomFieldTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    customFieldTypeGetAll(): Observable<CustomFieldTypeView[]> {
        let url_ = this.baseUrl + "/api/CustomFieldType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomFieldTypeGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomFieldTypeGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFieldTypeView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFieldTypeView[]>;
        }));
    }

    protected processCustomFieldTypeGetAll(response: HttpResponseBase): Observable<CustomFieldTypeView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomFieldTypeView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDivisionClient {
    /**
     * @return OK
     */
    divisionGetById(id: number): Observable<DivisionView>;
    /**
     * @return OK
     */
    divisionSearch(body: SearchDivisionsParameters): Observable<DivisionView[]>;
    /**
     * @return OK
     */
    divisionSave(body: DivisionView[]): Observable<DivisionView[]>;
    /**
     * @return OK
     */
    divisionActivate(id: number): Observable<void>;
    /**
     * @return OK
     */
    divisionDeactivate(id: number): Observable<void>;
}

@Injectable({ providedIn: 'root' })
export class DivisionClient extends BaseClient implements IDivisionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    divisionGetById(id: number): Observable<DivisionView> {
        let url_ = this.baseUrl + "/api/Division/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDivisionGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDivisionGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DivisionView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DivisionView>;
        }));
    }

    protected processDivisionGetById(response: HttpResponseBase): Observable<DivisionView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DivisionView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    divisionSearch(body: SearchDivisionsParameters): Observable<DivisionView[]> {
        let url_ = this.baseUrl + "/api/Division/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDivisionSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDivisionSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DivisionView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DivisionView[]>;
        }));
    }

    protected processDivisionSearch(response: HttpResponseBase): Observable<DivisionView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DivisionView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    divisionSave(body: DivisionView[]): Observable<DivisionView[]> {
        let url_ = this.baseUrl + "/api/Division";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDivisionSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDivisionSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DivisionView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DivisionView[]>;
        }));
    }

    protected processDivisionSave(response: HttpResponseBase): Observable<DivisionView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DivisionView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    divisionActivate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Division/activate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDivisionActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDivisionActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDivisionActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    divisionDeactivate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Division/deactivate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDivisionDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDivisionDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDivisionDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEntityTypeClient {
    /**
     * @return OK
     */
    entityTypeGetAll(): Observable<EntityTypeView[]>;
    /**
     * @return OK
     */
    entityTypeGetReserveOptions(): Observable<ReserveEntityOptionView[]>;
    /**
     * @return OK
     */
    entityTypeSearchMainEntities(body: SearchMainEntitiesParameters): Observable<SearchMainEntitiesResultDto[]>;
    /**
     * @return OK
     */
    entityTypeGetEntityCounters(body: GetEntityCountersParameters): Observable<EntityTypeCounterDto[]>;
    /**
     * @return OK
     */
    entityTypeAvailableColumns(entityType: number): Observable<EntitySearchColumnDto[]>;
}

@Injectable({ providedIn: 'root' })
export class EntityTypeClient extends BaseClient implements IEntityTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    entityTypeGetAll(): Observable<EntityTypeView[]> {
        let url_ = this.baseUrl + "/api/EntityType/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntityTypeGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntityTypeGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityTypeView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityTypeView[]>;
        }));
    }

    protected processEntityTypeGetAll(response: HttpResponseBase): Observable<EntityTypeView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityTypeView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    entityTypeGetReserveOptions(): Observable<ReserveEntityOptionView[]> {
        let url_ = this.baseUrl + "/api/EntityType/reserved-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntityTypeGetReserveOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntityTypeGetReserveOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReserveEntityOptionView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReserveEntityOptionView[]>;
        }));
    }

    protected processEntityTypeGetReserveOptions(response: HttpResponseBase): Observable<ReserveEntityOptionView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReserveEntityOptionView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    entityTypeSearchMainEntities(body: SearchMainEntitiesParameters): Observable<SearchMainEntitiesResultDto[]> {
        let url_ = this.baseUrl + "/api/EntityType/search-main-entities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntityTypeSearchMainEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntityTypeSearchMainEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchMainEntitiesResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchMainEntitiesResultDto[]>;
        }));
    }

    protected processEntityTypeSearchMainEntities(response: HttpResponseBase): Observable<SearchMainEntitiesResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchMainEntitiesResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    entityTypeGetEntityCounters(body: GetEntityCountersParameters): Observable<EntityTypeCounterDto[]> {
        let url_ = this.baseUrl + "/api/EntityType/entity-counters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntityTypeGetEntityCounters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntityTypeGetEntityCounters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityTypeCounterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityTypeCounterDto[]>;
        }));
    }

    protected processEntityTypeGetEntityCounters(response: HttpResponseBase): Observable<EntityTypeCounterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityTypeCounterDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    entityTypeAvailableColumns(entityType: number): Observable<EntitySearchColumnDto[]> {
        let url_ = this.baseUrl + "/api/EntityType/available-columns/{entityType}";
        if (entityType === undefined || entityType === null)
            throw new globalThis.Error("The parameter 'entityType' must be defined.");
        url_ = url_.replace("{entityType}", encodeURIComponent("" + entityType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntityTypeAvailableColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntityTypeAvailableColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntitySearchColumnDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntitySearchColumnDto[]>;
        }));
    }

    protected processEntityTypeAvailableColumns(response: HttpResponseBase): Observable<EntitySearchColumnDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntitySearchColumnDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEntityTypeCustomFieldClient {
    /**
     * @return OK
     */
    entityTypeCustomFieldSearch(body: SearchEntityTypeCustomFieldParameters): Observable<EntityTypeCustomFieldView[]>;
    /**
     * @return OK
     */
    entityTypeCustomFieldSave(body: EntityTypeCustomFieldView[]): Observable<EntityTypeCustomFieldView[]>;
    /**
     * @return OK
     */
    entityTypeCustomFieldGetCustomFieldsByEntityType(entityTypeId: number): Observable<EntityCustomFieldValueView[]>;
    /**
     * @return OK
     */
    entityTypeCustomFieldActivate(id: number): Observable<void>;
    /**
     * @return OK
     */
    entityTypeCustomFieldDeactivate(id: number): Observable<void>;
}

@Injectable({ providedIn: 'root' })
export class EntityTypeCustomFieldClient extends BaseClient implements IEntityTypeCustomFieldClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    entityTypeCustomFieldSearch(body: SearchEntityTypeCustomFieldParameters): Observable<EntityTypeCustomFieldView[]> {
        let url_ = this.baseUrl + "/api/EntityTypeCustomField/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntityTypeCustomFieldSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntityTypeCustomFieldSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityTypeCustomFieldView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityTypeCustomFieldView[]>;
        }));
    }

    protected processEntityTypeCustomFieldSearch(response: HttpResponseBase): Observable<EntityTypeCustomFieldView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityTypeCustomFieldView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    entityTypeCustomFieldSave(body: EntityTypeCustomFieldView[]): Observable<EntityTypeCustomFieldView[]> {
        let url_ = this.baseUrl + "/api/EntityTypeCustomField/save-custom-fields";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntityTypeCustomFieldSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntityTypeCustomFieldSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityTypeCustomFieldView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityTypeCustomFieldView[]>;
        }));
    }

    protected processEntityTypeCustomFieldSave(response: HttpResponseBase): Observable<EntityTypeCustomFieldView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityTypeCustomFieldView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    entityTypeCustomFieldGetCustomFieldsByEntityType(entityTypeId: number): Observable<EntityCustomFieldValueView[]> {
        let url_ = this.baseUrl + "/api/EntityTypeCustomField/{entityTypeId}";
        if (entityTypeId === undefined || entityTypeId === null)
            throw new globalThis.Error("The parameter 'entityTypeId' must be defined.");
        url_ = url_.replace("{entityTypeId}", encodeURIComponent("" + entityTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntityTypeCustomFieldGetCustomFieldsByEntityType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntityTypeCustomFieldGetCustomFieldsByEntityType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityCustomFieldValueView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityCustomFieldValueView[]>;
        }));
    }

    protected processEntityTypeCustomFieldGetCustomFieldsByEntityType(response: HttpResponseBase): Observable<EntityCustomFieldValueView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityCustomFieldValueView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    entityTypeCustomFieldActivate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/EntityTypeCustomField/activate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntityTypeCustomFieldActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntityTypeCustomFieldActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEntityTypeCustomFieldActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    entityTypeCustomFieldDeactivate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/EntityTypeCustomField/deactivate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntityTypeCustomFieldDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntityTypeCustomFieldDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEntityTypeCustomFieldDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEntityTypeCustomFieldSectionClient {
    /**
     * @return OK
     */
    entityTypeCustomFieldSectionGetByEntityType(entityTypeId: number): Observable<EntityTypeCustomFieldSectionView[]>;
}

@Injectable({ providedIn: 'root' })
export class EntityTypeCustomFieldSectionClient extends BaseClient implements IEntityTypeCustomFieldSectionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    entityTypeCustomFieldSectionGetByEntityType(entityTypeId: number): Observable<EntityTypeCustomFieldSectionView[]> {
        let url_ = this.baseUrl + "/api/EntityTypeCustomFieldSection/{entityTypeId}";
        if (entityTypeId === undefined || entityTypeId === null)
            throw new globalThis.Error("The parameter 'entityTypeId' must be defined.");
        url_ = url_.replace("{entityTypeId}", encodeURIComponent("" + entityTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntityTypeCustomFieldSectionGetByEntityType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntityTypeCustomFieldSectionGetByEntityType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityTypeCustomFieldSectionView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityTypeCustomFieldSectionView[]>;
        }));
    }

    protected processEntityTypeCustomFieldSectionGetByEntityType(response: HttpResponseBase): Observable<EntityTypeCustomFieldSectionView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityTypeCustomFieldSectionView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEstimateClient {
    /**
     * @return OK
     */
    estimateGetFinalEstimateOverview(estimateId: number): Observable<OpportunityEstimateView>;
    /**
     * @return OK
     */
    estimateSyncOpportunityStatus(estimateId: number, statusId: number): Observable<void>;
    /**
     * @return OK
     */
    estimateDeleteEstimate(estimateId: number): Observable<void>;
    /**
     * @return OK
     */
    estimateGetOpportunityStatusAvailable(estimateId: number): Observable<OpportunityStatusAvailableDto[]>;
    /**
     * @return OK
     */
    estimateChangeOpportunityStatus(estimateId: number, statusId: number): Observable<ChangeOpportunityStatusResultDto>;
}

@Injectable({ providedIn: 'root' })
export class EstimateClient extends BaseClient implements IEstimateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    estimateGetFinalEstimateOverview(estimateId: number): Observable<OpportunityEstimateView> {
        let url_ = this.baseUrl + "/api/Estimate/final-estimate/{estimateId}";
        if (estimateId === undefined || estimateId === null)
            throw new globalThis.Error("The parameter 'estimateId' must be defined.");
        url_ = url_.replace("{estimateId}", encodeURIComponent("" + estimateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateGetFinalEstimateOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateGetFinalEstimateOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityEstimateView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityEstimateView>;
        }));
    }

    protected processEstimateGetFinalEstimateOverview(response: HttpResponseBase): Observable<OpportunityEstimateView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityEstimateView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    estimateSyncOpportunityStatus(estimateId: number, statusId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Estimate/base-estimate-status/{estimateId}/{statusId}";
        if (estimateId === undefined || estimateId === null)
            throw new globalThis.Error("The parameter 'estimateId' must be defined.");
        url_ = url_.replace("{estimateId}", encodeURIComponent("" + estimateId));
        if (statusId === undefined || statusId === null)
            throw new globalThis.Error("The parameter 'statusId' must be defined.");
        url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateSyncOpportunityStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateSyncOpportunityStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEstimateSyncOpportunityStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    estimateDeleteEstimate(estimateId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Estimate/{estimateId}";
        if (estimateId === undefined || estimateId === null)
            throw new globalThis.Error("The parameter 'estimateId' must be defined.");
        url_ = url_.replace("{estimateId}", encodeURIComponent("" + estimateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateDeleteEstimate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateDeleteEstimate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEstimateDeleteEstimate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    estimateGetOpportunityStatusAvailable(estimateId: number): Observable<OpportunityStatusAvailableDto[]> {
        let url_ = this.baseUrl + "/api/Estimate/opportunity-status-available/{estimateId}";
        if (estimateId === undefined || estimateId === null)
            throw new globalThis.Error("The parameter 'estimateId' must be defined.");
        url_ = url_.replace("{estimateId}", encodeURIComponent("" + estimateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateGetOpportunityStatusAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateGetOpportunityStatusAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityStatusAvailableDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityStatusAvailableDto[]>;
        }));
    }

    protected processEstimateGetOpportunityStatusAvailable(response: HttpResponseBase): Observable<OpportunityStatusAvailableDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityStatusAvailableDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    estimateChangeOpportunityStatus(estimateId: number, statusId: number): Observable<ChangeOpportunityStatusResultDto> {
        let url_ = this.baseUrl + "/api/Estimate/opportunity-status-change/{estimateId}/{statusId}";
        if (estimateId === undefined || estimateId === null)
            throw new globalThis.Error("The parameter 'estimateId' must be defined.");
        url_ = url_.replace("{estimateId}", encodeURIComponent("" + estimateId));
        if (statusId === undefined || statusId === null)
            throw new globalThis.Error("The parameter 'statusId' must be defined.");
        url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateChangeOpportunityStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateChangeOpportunityStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangeOpportunityStatusResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangeOpportunityStatusResultDto>;
        }));
    }

    protected processEstimateChangeOpportunityStatus(response: HttpResponseBase): Observable<ChangeOpportunityStatusResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChangeOpportunityStatusResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEstimateTypeClient {
    /**
     * @return OK
     */
    estimateTypeGetAll(): Observable<EstimateTypeView[]>;
    /**
     * @return OK
     */
    estimateTypeGetAwardablesEstimateTypes(): Observable<EstimateTypeView[]>;
}

@Injectable({ providedIn: 'root' })
export class EstimateTypeClient extends BaseClient implements IEstimateTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    estimateTypeGetAll(): Observable<EstimateTypeView[]> {
        let url_ = this.baseUrl + "/api/EstimateType/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateTypeGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateTypeGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EstimateTypeView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EstimateTypeView[]>;
        }));
    }

    protected processEstimateTypeGetAll(response: HttpResponseBase): Observable<EstimateTypeView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EstimateTypeView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    estimateTypeGetAwardablesEstimateTypes(): Observable<EstimateTypeView[]> {
        let url_ = this.baseUrl + "/api/EstimateType/awardables";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEstimateTypeGetAwardablesEstimateTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEstimateTypeGetAwardablesEstimateTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EstimateTypeView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EstimateTypeView[]>;
        }));
    }

    protected processEstimateTypeGetAwardablesEstimateTypes(response: HttpResponseBase): Observable<EstimateTypeView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EstimateTypeView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ILeadSourceClient {
    /**
     * @return OK
     */
    leadSourceGetAll(): Observable<LeadSourceView[]>;
}

@Injectable({ providedIn: 'root' })
export class LeadSourceClient extends BaseClient implements ILeadSourceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    leadSourceGetAll(): Observable<LeadSourceView[]> {
        let url_ = this.baseUrl + "/api/LeadSource/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLeadSourceGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeadSourceGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeadSourceView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeadSourceView[]>;
        }));
    }

    protected processLeadSourceGetAll(response: HttpResponseBase): Observable<LeadSourceView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LeadSourceView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ILegalStatusClient {
    /**
     * @return OK
     */
    legalStatusGetById(id: number): Observable<LegalStatusView>;
    /**
     * @return OK
     */
    legalStatusGetAll(): Observable<LegalStatusView[]>;
}

@Injectable({ providedIn: 'root' })
export class LegalStatusClient extends BaseClient implements ILegalStatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    legalStatusGetById(id: number): Observable<LegalStatusView> {
        let url_ = this.baseUrl + "/api/LegalStatus/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLegalStatusGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLegalStatusGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LegalStatusView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LegalStatusView>;
        }));
    }

    protected processLegalStatusGetById(response: HttpResponseBase): Observable<LegalStatusView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LegalStatusView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    legalStatusGetAll(): Observable<LegalStatusView[]> {
        let url_ = this.baseUrl + "/api/LegalStatus/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLegalStatusGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLegalStatusGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LegalStatusView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LegalStatusView[]>;
        }));
    }

    protected processLegalStatusGetAll(response: HttpResponseBase): Observable<LegalStatusView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LegalStatusView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ILoginClient {
    /**
     * @param body (optional) 
     * @return OK
     */
    loginAuthenticate(body: LoginDto | undefined): Observable<TokenResultDto>;
    /**
     * @return OK
     */
    loginSendForgotPasswordRequest(body: ForgotPasswordDto): Observable<void>;
    /**
     * @return OK
     */
    loginLogOut(): Observable<void>;
}

@Injectable({ providedIn: 'root' })
export class LoginClient extends BaseClient implements ILoginClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    loginAuthenticate(body: LoginDto | undefined): Observable<TokenResultDto> {
        let url_ = this.baseUrl + "/api/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenResultDto>;
        }));
    }

    protected processLoginAuthenticate(response: HttpResponseBase): Observable<TokenResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TokenResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    loginSendForgotPasswordRequest(body: ForgotPasswordDto): Observable<void> {
        let url_ = this.baseUrl + "/api/Login/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginSendForgotPasswordRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginSendForgotPasswordRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLoginSendForgotPasswordRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    loginLogOut(): Observable<void> {
        let url_ = this.baseUrl + "/api/Login/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginLogOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginLogOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLoginLogOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMarketClient {
    /**
     * @return OK
     */
    marketGetById(id: number): Observable<MarketView>;
    /**
     * @return OK
     */
    marketGetAll(): Observable<MarketView[]>;
}

@Injectable({ providedIn: 'root' })
export class MarketClient extends BaseClient implements IMarketClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    marketGetById(id: number): Observable<MarketView> {
        let url_ = this.baseUrl + "/api/Market/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarketGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarketGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketView>;
        }));
    }

    protected processMarketGetById(response: HttpResponseBase): Observable<MarketView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    marketGetAll(): Observable<MarketView[]> {
        let url_ = this.baseUrl + "/api/Market/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarketGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarketGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarketView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarketView[]>;
        }));
    }

    protected processMarketGetAll(response: HttpResponseBase): Observable<MarketView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMaterialClient {
    /**
     * @return OK
     */
    materialGetById(id: number): Observable<MaterialView>;
    /**
     * @return OK
     */
    materialGetAll(): Observable<MaterialView[]>;
}

@Injectable({ providedIn: 'root' })
export class MaterialClient extends BaseClient implements IMaterialClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    materialGetById(id: number): Observable<MaterialView> {
        let url_ = this.baseUrl + "/api/Material/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMaterialGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMaterialGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialView>;
        }));
    }

    protected processMaterialGetById(response: HttpResponseBase): Observable<MaterialView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaterialView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    materialGetAll(): Observable<MaterialView[]> {
        let url_ = this.baseUrl + "/api/Material/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMaterialGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMaterialGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialView[]>;
        }));
    }

    protected processMaterialGetAll(response: HttpResponseBase): Observable<MaterialView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaterialView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INoteClient {
    /**
     * @return OK
     */
    noteSearch(body: SearchNotesParameters): Observable<NoteViewPaginatedResultDto>;
    /**
     * @return OK
     */
    noteSave(body: NoteView): Observable<NoteView>;
    /**
     * @return OK
     */
    noteDelete(id: number): Observable<void>;
    /**
     * @return OK
     */
    noteGetById(id: number): Observable<NoteView>;
}

@Injectable({ providedIn: 'root' })
export class NoteClient extends BaseClient implements INoteClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    noteSearch(body: SearchNotesParameters): Observable<NoteViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/Note/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNoteSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNoteSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NoteViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NoteViewPaginatedResultDto>;
        }));
    }

    protected processNoteSearch(response: HttpResponseBase): Observable<NoteViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    noteSave(body: NoteView): Observable<NoteView> {
        let url_ = this.baseUrl + "/api/Note";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNoteSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNoteSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NoteView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NoteView>;
        }));
    }

    protected processNoteSave(response: HttpResponseBase): Observable<NoteView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    noteDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Note/delete/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNoteDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNoteDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNoteDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    noteGetById(id: number): Observable<NoteView> {
        let url_ = this.baseUrl + "/api/Note/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNoteGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNoteGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NoteView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NoteView>;
        }));
    }

    protected processNoteGetById(response: HttpResponseBase): Observable<NoteView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INotificationClient {
    /**
     * @return OK
     */
    notificationSearch(body: SearchNotificationsParameters): Observable<NotificationViewPaginatedResultDto>;
    /**
     * @return OK
     */
    notificationGetLatestForCurrentUser(): Observable<NotificationView[]>;
    /**
     * @return OK
     */
    notificationMarkAllAsRead(): Observable<number>;
    /**
     * @return OK
     */
    notificationMarkAsRead(id: number): Observable<void>;
}

@Injectable({ providedIn: 'root' })
export class NotificationClient extends BaseClient implements INotificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    notificationSearch(body: SearchNotificationsParameters): Observable<NotificationViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/Notification/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationViewPaginatedResultDto>;
        }));
    }

    protected processNotificationSearch(response: HttpResponseBase): Observable<NotificationViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    notificationGetLatestForCurrentUser(): Observable<NotificationView[]> {
        let url_ = this.baseUrl + "/api/Notification/latest-notifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationGetLatestForCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationGetLatestForCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationView[]>;
        }));
    }

    protected processNotificationGetLatestForCurrentUser(response: HttpResponseBase): Observable<NotificationView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    notificationMarkAllAsRead(): Observable<number> {
        let url_ = this.baseUrl + "/api/Notification/mark-all-as-read";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationMarkAllAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationMarkAllAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processNotificationMarkAllAsRead(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    notificationMarkAsRead(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Notification/mark-as-read/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationMarkAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationMarkAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotificationMarkAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INotificationTypeUserConfigurationClient {
    /**
     * @return OK
     */
    notificationTypeUserConfigurationGetForCurrentUser(): Observable<NotificationTypeUserConfigurationView[]>;
    /**
     * @return OK
     */
    notificationTypeUserConfigurationSave(body: NotificationTypeUserConfigurationView[]): Observable<NotificationTypeUserConfigurationView[]>;
}

@Injectable({ providedIn: 'root' })
export class NotificationTypeUserConfigurationClient extends BaseClient implements INotificationTypeUserConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    notificationTypeUserConfigurationGetForCurrentUser(): Observable<NotificationTypeUserConfigurationView[]> {
        let url_ = this.baseUrl + "/api/NotificationTypeUserConfiguration/notification-configurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationTypeUserConfigurationGetForCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationTypeUserConfigurationGetForCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationTypeUserConfigurationView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationTypeUserConfigurationView[]>;
        }));
    }

    protected processNotificationTypeUserConfigurationGetForCurrentUser(response: HttpResponseBase): Observable<NotificationTypeUserConfigurationView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationTypeUserConfigurationView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    notificationTypeUserConfigurationSave(body: NotificationTypeUserConfigurationView[]): Observable<NotificationTypeUserConfigurationView[]> {
        let url_ = this.baseUrl + "/api/NotificationTypeUserConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationTypeUserConfigurationSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationTypeUserConfigurationSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationTypeUserConfigurationView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationTypeUserConfigurationView[]>;
        }));
    }

    protected processNotificationTypeUserConfigurationSave(response: HttpResponseBase): Observable<NotificationTypeUserConfigurationView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationTypeUserConfigurationView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOpportunityClient {
    /**
     * @return OK
     */
    opportunityGetById(id: number): Observable<OpportunityView>;
    /**
     * @param body (optional) 
     * @return OK
     */
    opportunityPatch(id: number, body: PatchOpportunityViewJsonPatchDocument | undefined): Observable<void>;
    /**
     * @return OK
     */
    opportunitySave(body: OpportunityView): Observable<OpportunityView>;
    /**
     * @param body (optional) 
     * @return OK
     */
    opportunitySearch(body: SearchOpportunitiesParameters | undefined): Observable<SearchOpportunitiesResultPaginatedResultDto>;
    /**
     * @param body (optional) 
     * @return OK
     */
    opportunitySearchCalendar(body: SearchOpportunitiesCalendarParameters | undefined): Observable<SearchOpportunitiesCalendarResult[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    opportunityMapSearch(body: SearchOpportunitiesMapParameters | undefined): Observable<OpportunityMapResult[]>;
    /**
     * @return OK
     */
    opportunitySaveUser(body: OpportunityUserView): Observable<OpportunityUserView>;
    /**
     * @return OK
     */
    opportunitySetAsFavorite(id: number): Observable<void>;
    /**
     * @return OK
     */
    opportunityRemoveFromFavorite(id: number): Observable<void>;
    /**
     * @return OK
     */
    opportunitySaveContact(body: OpportunityContactView): Observable<OpportunityContactView>;
    /**
     * @return OK
     */
    opportunitySaveCompany(body: OpportunityCompanyView): Observable<OpportunityCompanyView>;
    /**
     * @return OK
     */
    opportunitySaveBuilding(body: OpportunityBuildingView): Observable<OpportunityBuildingView>;
    /**
     * @return OK
     */
    opportunityActivate(id: number): Observable<void>;
    /**
     * @return OK
     */
    opportunityDeactivate(id: number): Observable<void>;
    /**
     * @return OK
     */
    opportunitySyncOpportunityEstimates(id: number): Observable<void>;
    /**
     * @return OK
     */
    opportunityValidateForEstimateCreation(id: number): Observable<DomainValidationResult[]>;
    /**
     * @return OK
     */
    opportunityAvailableActions(id: number): Observable<number[]>;
    /**
     * @return OK
     */
    opportunityGetActualValues(id: number): Observable<GetOpportunityActualValuesResultDto>;
    /**
     * @return OK
     */
    opportunitySaveOpportunityManual(body: CreateOpportunityManualParameters): Observable<OpportunityManualView>;
    /**
     * @return OK
     */
    opportunityEdit(id: number, body: EditOpportunityView): Observable<void>;
    /**
     * @return OK
     */
    opportunityGetTerm(id: number): Observable<GetOpportunityTermResultDto>;
    /**
     * @return OK
     */
    opportunityDisqualified(id: number): Observable<ChangeOpportunityStatusResultDto>;
    /**
     * @return OK
     */
    opportunityUnqualified(id: number): Observable<ChangeOpportunityStatusResultDto>;
}

@Injectable({ providedIn: 'root' })
export class OpportunityClient extends BaseClient implements IOpportunityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    opportunityGetById(id: number): Observable<OpportunityView> {
        let url_ = this.baseUrl + "/api/Opportunity/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityView>;
        }));
    }

    protected processOpportunityGetById(response: HttpResponseBase): Observable<OpportunityView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    opportunityPatch(id: number, body: PatchOpportunityViewJsonPatchDocument | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Opportunity/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpportunityPatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunitySave(body: OpportunityView): Observable<OpportunityView> {
        let url_ = this.baseUrl + "/api/Opportunity/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunitySave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunitySave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityView>;
        }));
    }

    protected processOpportunitySave(response: HttpResponseBase): Observable<OpportunityView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    opportunitySearch(body: SearchOpportunitiesParameters | undefined): Observable<SearchOpportunitiesResultPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/Opportunity/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunitySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunitySearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchOpportunitiesResultPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchOpportunitiesResultPaginatedResultDto>;
        }));
    }

    protected processOpportunitySearch(response: HttpResponseBase): Observable<SearchOpportunitiesResultPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchOpportunitiesResultPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    opportunitySearchCalendar(body: SearchOpportunitiesCalendarParameters | undefined): Observable<SearchOpportunitiesCalendarResult[]> {
        let url_ = this.baseUrl + "/api/Opportunity/search-calendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunitySearchCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunitySearchCalendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchOpportunitiesCalendarResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchOpportunitiesCalendarResult[]>;
        }));
    }

    protected processOpportunitySearchCalendar(response: HttpResponseBase): Observable<SearchOpportunitiesCalendarResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchOpportunitiesCalendarResult[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    opportunityMapSearch(body: SearchOpportunitiesMapParameters | undefined): Observable<OpportunityMapResult[]> {
        let url_ = this.baseUrl + "/api/Opportunity/search-map";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityMapSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityMapSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityMapResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityMapResult[]>;
        }));
    }

    protected processOpportunityMapSearch(response: HttpResponseBase): Observable<OpportunityMapResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityMapResult[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunitySaveUser(body: OpportunityUserView): Observable<OpportunityUserView> {
        let url_ = this.baseUrl + "/api/Opportunity/save-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunitySaveUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunitySaveUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityUserView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityUserView>;
        }));
    }

    protected processOpportunitySaveUser(response: HttpResponseBase): Observable<OpportunityUserView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityUserView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunitySetAsFavorite(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Opportunity/set-favorite/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunitySetAsFavorite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunitySetAsFavorite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpportunitySetAsFavorite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityRemoveFromFavorite(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Opportunity/remove-favorite/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityRemoveFromFavorite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityRemoveFromFavorite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpportunityRemoveFromFavorite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunitySaveContact(body: OpportunityContactView): Observable<OpportunityContactView> {
        let url_ = this.baseUrl + "/api/Opportunity/save-contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunitySaveContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunitySaveContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityContactView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityContactView>;
        }));
    }

    protected processOpportunitySaveContact(response: HttpResponseBase): Observable<OpportunityContactView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityContactView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunitySaveCompany(body: OpportunityCompanyView): Observable<OpportunityCompanyView> {
        let url_ = this.baseUrl + "/api/Opportunity/save-company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunitySaveCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunitySaveCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityCompanyView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityCompanyView>;
        }));
    }

    protected processOpportunitySaveCompany(response: HttpResponseBase): Observable<OpportunityCompanyView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityCompanyView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunitySaveBuilding(body: OpportunityBuildingView): Observable<OpportunityBuildingView> {
        let url_ = this.baseUrl + "/api/Opportunity/save-building";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunitySaveBuilding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunitySaveBuilding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityBuildingView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityBuildingView>;
        }));
    }

    protected processOpportunitySaveBuilding(response: HttpResponseBase): Observable<OpportunityBuildingView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityBuildingView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityActivate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Opportunity/activate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpportunityActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityDeactivate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Opportunity/deactivate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpportunityDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunitySyncOpportunityEstimates(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Opportunity/estimates/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunitySyncOpportunityEstimates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunitySyncOpportunityEstimates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpportunitySyncOpportunityEstimates(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityValidateForEstimateCreation(id: number): Observable<DomainValidationResult[]> {
        let url_ = this.baseUrl + "/api/Opportunity/validate-for-estimate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityValidateForEstimateCreation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityValidateForEstimateCreation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DomainValidationResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DomainValidationResult[]>;
        }));
    }

    protected processOpportunityValidateForEstimateCreation(response: HttpResponseBase): Observable<DomainValidationResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DomainValidationResult[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityAvailableActions(id: number): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Opportunity/available-actions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityAvailableActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityAvailableActions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processOpportunityAvailableActions(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityGetActualValues(id: number): Observable<GetOpportunityActualValuesResultDto> {
        let url_ = this.baseUrl + "/api/Opportunity/get-actual-values/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityGetActualValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityGetActualValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOpportunityActualValuesResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOpportunityActualValuesResultDto>;
        }));
    }

    protected processOpportunityGetActualValues(response: HttpResponseBase): Observable<GetOpportunityActualValuesResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOpportunityActualValuesResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunitySaveOpportunityManual(body: CreateOpportunityManualParameters): Observable<OpportunityManualView> {
        let url_ = this.baseUrl + "/api/Opportunity/save-manual";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunitySaveOpportunityManual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunitySaveOpportunityManual(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityManualView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityManualView>;
        }));
    }

    protected processOpportunitySaveOpportunityManual(response: HttpResponseBase): Observable<OpportunityManualView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityManualView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityEdit(id: number, body: EditOpportunityView): Observable<void> {
        let url_ = this.baseUrl + "/api/Opportunity/edit/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpportunityEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityGetTerm(id: number): Observable<GetOpportunityTermResultDto> {
        let url_ = this.baseUrl + "/api/Opportunity/get-term/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityGetTerm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityGetTerm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOpportunityTermResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOpportunityTermResultDto>;
        }));
    }

    protected processOpportunityGetTerm(response: HttpResponseBase): Observable<GetOpportunityTermResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOpportunityTermResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityDisqualified(id: number): Observable<ChangeOpportunityStatusResultDto> {
        let url_ = this.baseUrl + "/api/Opportunity/disqualified/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityDisqualified(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityDisqualified(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangeOpportunityStatusResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangeOpportunityStatusResultDto>;
        }));
    }

    protected processOpportunityDisqualified(response: HttpResponseBase): Observable<ChangeOpportunityStatusResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChangeOpportunityStatusResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityUnqualified(id: number): Observable<ChangeOpportunityStatusResultDto> {
        let url_ = this.baseUrl + "/api/Opportunity/unqualified/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityUnqualified(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityUnqualified(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangeOpportunityStatusResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangeOpportunityStatusResultDto>;
        }));
    }

    protected processOpportunityUnqualified(response: HttpResponseBase): Observable<ChangeOpportunityStatusResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ChangeOpportunityStatusResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOpportunityBuildingClient {
    /**
     * @return OK
     */
    opportunityBuildingSearchForOpportunity(body: SearchBuildingsForOpportunityParameters): Observable<OpportunityBuildingViewPaginatedResultDto>;
    /**
     * @return OK
     */
    opportunityBuildingSearchAvailable(body: SearchAvailableOpportunityBuildingsParameters): Observable<BuildingView[]>;
    /**
     * @return OK
     */
    opportunityBuildingSetBuildingAsMain(body: OpportunityBuildingView): Observable<void>;
    /**
     * @return OK
     */
    opportunityBuildingUnsetAsMain(body: OpportunityBuildingView): Observable<void>;
    /**
     * @return OK
     */
    opportunityBuildingDelete(id: number): Observable<void>;
}

@Injectable({ providedIn: 'root' })
export class OpportunityBuildingClient extends BaseClient implements IOpportunityBuildingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    opportunityBuildingSearchForOpportunity(body: SearchBuildingsForOpportunityParameters): Observable<OpportunityBuildingViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/OpportunityBuilding/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityBuildingSearchForOpportunity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityBuildingSearchForOpportunity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityBuildingViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityBuildingViewPaginatedResultDto>;
        }));
    }

    protected processOpportunityBuildingSearchForOpportunity(response: HttpResponseBase): Observable<OpportunityBuildingViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityBuildingViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityBuildingSearchAvailable(body: SearchAvailableOpportunityBuildingsParameters): Observable<BuildingView[]> {
        let url_ = this.baseUrl + "/api/OpportunityBuilding/search-available-buildings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityBuildingSearchAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityBuildingSearchAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingView[]>;
        }));
    }

    protected processOpportunityBuildingSearchAvailable(response: HttpResponseBase): Observable<BuildingView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BuildingView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityBuildingSetBuildingAsMain(body: OpportunityBuildingView): Observable<void> {
        let url_ = this.baseUrl + "/api/OpportunityBuilding/set-as-main";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityBuildingSetBuildingAsMain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityBuildingSetBuildingAsMain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpportunityBuildingSetBuildingAsMain(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityBuildingUnsetAsMain(body: OpportunityBuildingView): Observable<void> {
        let url_ = this.baseUrl + "/api/OpportunityBuilding/unset-as-main";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityBuildingUnsetAsMain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityBuildingUnsetAsMain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpportunityBuildingUnsetAsMain(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityBuildingDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OpportunityBuilding/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityBuildingDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityBuildingDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpportunityBuildingDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOpportunityChangeOrderEstimateClient {
    /**
     * @return OK
     */
    opportunityChangeOrderEstimateSearchChangeOrdersByOpportunity(body: SearchOpportunityEstimateParameters): Observable<OpportunityChangeOrderEstimateViewPaginatedResultDto>;
    /**
     * @return OK
     */
    opportunityChangeOrderEstimateGetCostsOverview(opportunityId: number): Observable<GetChangeOrderCostsResult>;
}

@Injectable({ providedIn: 'root' })
export class OpportunityChangeOrderEstimateClient extends BaseClient implements IOpportunityChangeOrderEstimateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    opportunityChangeOrderEstimateSearchChangeOrdersByOpportunity(body: SearchOpportunityEstimateParameters): Observable<OpportunityChangeOrderEstimateViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/OpportunityChangeOrderEstimate/search-change-orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityChangeOrderEstimateSearchChangeOrdersByOpportunity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityChangeOrderEstimateSearchChangeOrdersByOpportunity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityChangeOrderEstimateViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityChangeOrderEstimateViewPaginatedResultDto>;
        }));
    }

    protected processOpportunityChangeOrderEstimateSearchChangeOrdersByOpportunity(response: HttpResponseBase): Observable<OpportunityChangeOrderEstimateViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityChangeOrderEstimateViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityChangeOrderEstimateGetCostsOverview(opportunityId: number): Observable<GetChangeOrderCostsResult> {
        let url_ = this.baseUrl + "/api/OpportunityChangeOrderEstimate/costs/{opportunityId}";
        if (opportunityId === undefined || opportunityId === null)
            throw new globalThis.Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityChangeOrderEstimateGetCostsOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityChangeOrderEstimateGetCostsOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetChangeOrderCostsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetChangeOrderCostsResult>;
        }));
    }

    protected processOpportunityChangeOrderEstimateGetCostsOverview(response: HttpResponseBase): Observable<GetChangeOrderCostsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetChangeOrderCostsResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOpportunityCompanyClient {
    /**
     * @return OK
     */
    opportunityCompanySearchForOpportunity(body: SearchCompaniesForOpportunityParameters): Observable<OpportunityCompanyViewPaginatedResultDto>;
    /**
     * @return OK
     */
    opportunityCompanySearchAvailable(body: SearchAvailableOpportunityCompaniesParameters): Observable<CompanyView[]>;
    /**
     * @return OK
     */
    opportunityCompanyDelete(id: number): Observable<void>;
}

@Injectable({ providedIn: 'root' })
export class OpportunityCompanyClient extends BaseClient implements IOpportunityCompanyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    opportunityCompanySearchForOpportunity(body: SearchCompaniesForOpportunityParameters): Observable<OpportunityCompanyViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/OpportunityCompany/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityCompanySearchForOpportunity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityCompanySearchForOpportunity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityCompanyViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityCompanyViewPaginatedResultDto>;
        }));
    }

    protected processOpportunityCompanySearchForOpportunity(response: HttpResponseBase): Observable<OpportunityCompanyViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityCompanyViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityCompanySearchAvailable(body: SearchAvailableOpportunityCompaniesParameters): Observable<CompanyView[]> {
        let url_ = this.baseUrl + "/api/OpportunityCompany/search-available-companies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityCompanySearchAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityCompanySearchAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyView[]>;
        }));
    }

    protected processOpportunityCompanySearchAvailable(response: HttpResponseBase): Observable<CompanyView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompanyView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityCompanyDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OpportunityCompany/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityCompanyDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityCompanyDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpportunityCompanyDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOpportunityContactClient {
    /**
     * @return OK
     */
    opportunityContactSearchForOpportunity(body: SearchContactsForOpportunityParameters): Observable<OpportunityContactViewPaginatedResultDto>;
    /**
     * @return OK
     */
    opportunityContactUpdateContactCompany(id: number): Observable<OpportunityContactView>;
    /**
     * @return OK
     */
    opportunityContactDelete(id: number): Observable<void>;
    /**
     * @return OK
     */
    opportunityContactSearchAvailable(body: SearchAvailableOpportunityContactsParameters): Observable<ContactView[]>;
}

@Injectable({ providedIn: 'root' })
export class OpportunityContactClient extends BaseClient implements IOpportunityContactClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    opportunityContactSearchForOpportunity(body: SearchContactsForOpportunityParameters): Observable<OpportunityContactViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/OpportunityContact/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityContactSearchForOpportunity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityContactSearchForOpportunity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityContactViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityContactViewPaginatedResultDto>;
        }));
    }

    protected processOpportunityContactSearchForOpportunity(response: HttpResponseBase): Observable<OpportunityContactViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityContactViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityContactUpdateContactCompany(id: number): Observable<OpportunityContactView> {
        let url_ = this.baseUrl + "/api/OpportunityContact/update-company/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityContactUpdateContactCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityContactUpdateContactCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityContactView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityContactView>;
        }));
    }

    protected processOpportunityContactUpdateContactCompany(response: HttpResponseBase): Observable<OpportunityContactView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityContactView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityContactDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OpportunityContact/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityContactDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityContactDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpportunityContactDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityContactSearchAvailable(body: SearchAvailableOpportunityContactsParameters): Observable<ContactView[]> {
        let url_ = this.baseUrl + "/api/OpportunityContact/search-available-contacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityContactSearchAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityContactSearchAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactView[]>;
        }));
    }

    protected processOpportunityContactSearchAvailable(response: HttpResponseBase): Observable<ContactView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOpportunityDashboardClient {
    /**
     * @return OK
     */
    opportunityDashboardGetUpcomingBids(): Observable<OpportunityView[]>;
    /**
     * @return OK
     */
    opportunityDashboardGetNewProjects(): Observable<OpportunityView[]>;
    /**
     * @return OK
     */
    opportunityDashboardGetComparisonOptions(): Observable<DashboardComparisonOptionView[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    opportunityDashboardGetOpportunityStats(comparisonId: number, body: GetOpportunityStatsByPeriodParameters | undefined): Observable<GetOpportunityStatsByPeriodResultOpportunityTotalsResultDto>;
}

@Injectable({ providedIn: 'root' })
export class OpportunityDashboardClient extends BaseClient implements IOpportunityDashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    opportunityDashboardGetUpcomingBids(): Observable<OpportunityView[]> {
        let url_ = this.baseUrl + "/api/OpportunityDashboard/upcoming-bids";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityDashboardGetUpcomingBids(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityDashboardGetUpcomingBids(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityView[]>;
        }));
    }

    protected processOpportunityDashboardGetUpcomingBids(response: HttpResponseBase): Observable<OpportunityView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityDashboardGetNewProjects(): Observable<OpportunityView[]> {
        let url_ = this.baseUrl + "/api/OpportunityDashboard/new-projects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityDashboardGetNewProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityDashboardGetNewProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityView[]>;
        }));
    }

    protected processOpportunityDashboardGetNewProjects(response: HttpResponseBase): Observable<OpportunityView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityDashboardGetComparisonOptions(): Observable<DashboardComparisonOptionView[]> {
        let url_ = this.baseUrl + "/api/OpportunityDashboard/comparison-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityDashboardGetComparisonOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityDashboardGetComparisonOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardComparisonOptionView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardComparisonOptionView[]>;
        }));
    }

    protected processOpportunityDashboardGetComparisonOptions(response: HttpResponseBase): Observable<DashboardComparisonOptionView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardComparisonOptionView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    opportunityDashboardGetOpportunityStats(comparisonId: number, body: GetOpportunityStatsByPeriodParameters | undefined): Observable<GetOpportunityStatsByPeriodResultOpportunityTotalsResultDto> {
        let url_ = this.baseUrl + "/api/OpportunityDashboard/opportunity-stats/{comparisonId}";
        if (comparisonId === undefined || comparisonId === null)
            throw new globalThis.Error("The parameter 'comparisonId' must be defined.");
        url_ = url_.replace("{comparisonId}", encodeURIComponent("" + comparisonId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityDashboardGetOpportunityStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityDashboardGetOpportunityStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOpportunityStatsByPeriodResultOpportunityTotalsResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOpportunityStatsByPeriodResultOpportunityTotalsResultDto>;
        }));
    }

    protected processOpportunityDashboardGetOpportunityStats(response: HttpResponseBase): Observable<GetOpportunityStatsByPeriodResultOpportunityTotalsResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOpportunityStatsByPeriodResultOpportunityTotalsResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOpportunityEstimateClient {
    /**
     * @return OK
     */
    opportunityEstimateSearchAvailableBase(body: SearchAvailableBaseEstimatesParameters): Observable<SearchBaseEstimateResultDto[]>;
    /**
     * @return OK
     */
    opportunityEstimateSearchBaseEstimateTemplates(body: SearchEstimateTemplatesParameters): Observable<SearchEstimateTemplatesResultDto[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    opportunityEstimateCreateBaseEstimate(body: CreateBaseEstimateParameters | undefined): Observable<OpportunityEstimateView>;
    /**
     * @return OK
     */
    opportunityEstimateLink(body: LinkOpportunityEstimateDto): Observable<OpportunityEstimateView>;
    /**
     * @return OK
     */
    opportunityEstimateUnlink(opportunityId: number): Observable<UnlinkOpportunityEstimateResultDto>;
    /**
     * @return OK
     */
    opportunityEstimateGetEstimatesInfoByOpportunity(opportunityId: number): Observable<OpportunityEstimateView[]>;
    /**
     * @return OK
     */
    opportunityEstimateSearchFinalEstimatesByOpportunity(body: SearchOpportunityEstimateParameters): Observable<OpportunityEstimateViewPaginatedResultDto>;
    /**
     * @return OK
     */
    opportunityEstimateSearchAlternateEstimatesByOpportunity(body: SearchOpportunityEstimateParameters): Observable<OpportunityEstimateViewPaginatedResultDto>;
    /**
     * @return OK
     */
    opportunityEstimateCreateOpportunityEstimate(body: CreateOpportunityEstimateDto): Observable<CreateOpportunityEstimateResultDto>;
    /**
     * @return OK
     */
    opportunityEstimateSyncOpportunityUsers(opportunityId: number, body: number[]): Observable<void>;
}

@Injectable({ providedIn: 'root' })
export class OpportunityEstimateClient extends BaseClient implements IOpportunityEstimateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    opportunityEstimateSearchAvailableBase(body: SearchAvailableBaseEstimatesParameters): Observable<SearchBaseEstimateResultDto[]> {
        let url_ = this.baseUrl + "/api/OpportunityEstimate/search-available";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityEstimateSearchAvailableBase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityEstimateSearchAvailableBase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchBaseEstimateResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchBaseEstimateResultDto[]>;
        }));
    }

    protected processOpportunityEstimateSearchAvailableBase(response: HttpResponseBase): Observable<SearchBaseEstimateResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchBaseEstimateResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityEstimateSearchBaseEstimateTemplates(body: SearchEstimateTemplatesParameters): Observable<SearchEstimateTemplatesResultDto[]> {
        let url_ = this.baseUrl + "/api/OpportunityEstimate/search-templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityEstimateSearchBaseEstimateTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityEstimateSearchBaseEstimateTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchEstimateTemplatesResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchEstimateTemplatesResultDto[]>;
        }));
    }

    protected processOpportunityEstimateSearchBaseEstimateTemplates(response: HttpResponseBase): Observable<SearchEstimateTemplatesResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchEstimateTemplatesResultDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    opportunityEstimateCreateBaseEstimate(body: CreateBaseEstimateParameters | undefined): Observable<OpportunityEstimateView> {
        let url_ = this.baseUrl + "/api/OpportunityEstimate/base-estimate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityEstimateCreateBaseEstimate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityEstimateCreateBaseEstimate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityEstimateView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityEstimateView>;
        }));
    }

    protected processOpportunityEstimateCreateBaseEstimate(response: HttpResponseBase): Observable<OpportunityEstimateView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityEstimateView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityEstimateLink(body: LinkOpportunityEstimateDto): Observable<OpportunityEstimateView> {
        let url_ = this.baseUrl + "/api/OpportunityEstimate/link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityEstimateLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityEstimateLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityEstimateView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityEstimateView>;
        }));
    }

    protected processOpportunityEstimateLink(response: HttpResponseBase): Observable<OpportunityEstimateView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityEstimateView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityEstimateUnlink(opportunityId: number): Observable<UnlinkOpportunityEstimateResultDto> {
        let url_ = this.baseUrl + "/api/OpportunityEstimate/unlink/{opportunityId}";
        if (opportunityId === undefined || opportunityId === null)
            throw new globalThis.Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityEstimateUnlink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityEstimateUnlink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnlinkOpportunityEstimateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnlinkOpportunityEstimateResultDto>;
        }));
    }

    protected processOpportunityEstimateUnlink(response: HttpResponseBase): Observable<UnlinkOpportunityEstimateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnlinkOpportunityEstimateResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityEstimateGetEstimatesInfoByOpportunity(opportunityId: number): Observable<OpportunityEstimateView[]> {
        let url_ = this.baseUrl + "/api/OpportunityEstimate/estimate-info/{opportunityId}";
        if (opportunityId === undefined || opportunityId === null)
            throw new globalThis.Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityEstimateGetEstimatesInfoByOpportunity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityEstimateGetEstimatesInfoByOpportunity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityEstimateView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityEstimateView[]>;
        }));
    }

    protected processOpportunityEstimateGetEstimatesInfoByOpportunity(response: HttpResponseBase): Observable<OpportunityEstimateView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityEstimateView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityEstimateSearchFinalEstimatesByOpportunity(body: SearchOpportunityEstimateParameters): Observable<OpportunityEstimateViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/OpportunityEstimate/search-final-estimates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityEstimateSearchFinalEstimatesByOpportunity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityEstimateSearchFinalEstimatesByOpportunity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityEstimateViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityEstimateViewPaginatedResultDto>;
        }));
    }

    protected processOpportunityEstimateSearchFinalEstimatesByOpportunity(response: HttpResponseBase): Observable<OpportunityEstimateViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityEstimateViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityEstimateSearchAlternateEstimatesByOpportunity(body: SearchOpportunityEstimateParameters): Observable<OpportunityEstimateViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/OpportunityEstimate/search-alternate-estimates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityEstimateSearchAlternateEstimatesByOpportunity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityEstimateSearchAlternateEstimatesByOpportunity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityEstimateViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityEstimateViewPaginatedResultDto>;
        }));
    }

    protected processOpportunityEstimateSearchAlternateEstimatesByOpportunity(response: HttpResponseBase): Observable<OpportunityEstimateViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityEstimateViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityEstimateCreateOpportunityEstimate(body: CreateOpportunityEstimateDto): Observable<CreateOpportunityEstimateResultDto> {
        let url_ = this.baseUrl + "/api/OpportunityEstimate/create-opportunity-estimate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityEstimateCreateOpportunityEstimate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityEstimateCreateOpportunityEstimate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOpportunityEstimateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOpportunityEstimateResultDto>;
        }));
    }

    protected processOpportunityEstimateCreateOpportunityEstimate(response: HttpResponseBase): Observable<CreateOpportunityEstimateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateOpportunityEstimateResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityEstimateSyncOpportunityUsers(opportunityId: number, body: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/OpportunityEstimate/sync-users/{opportunityId}";
        if (opportunityId === undefined || opportunityId === null)
            throw new globalThis.Error("The parameter 'opportunityId' must be defined.");
        url_ = url_.replace("{opportunityId}", encodeURIComponent("" + opportunityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityEstimateSyncOpportunityUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityEstimateSyncOpportunityUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpportunityEstimateSyncOpportunityUsers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOpportunityProbabilityClient {
    /**
     * @return OK
     */
    opportunityProbabilityGetAll(): Observable<OpportunityProbabilityView[]>;
}

@Injectable({ providedIn: 'root' })
export class OpportunityProbabilityClient extends BaseClient implements IOpportunityProbabilityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    opportunityProbabilityGetAll(): Observable<OpportunityProbabilityView[]> {
        let url_ = this.baseUrl + "/api/OpportunityProbability/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityProbabilityGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityProbabilityGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityProbabilityView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityProbabilityView[]>;
        }));
    }

    protected processOpportunityProbabilityGetAll(response: HttpResponseBase): Observable<OpportunityProbabilityView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityProbabilityView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOpportunityStatusClient {
    /**
     * @return OK
     */
    opportunityStatusGetAll(): Observable<OpportunityStatusView[]>;
    /**
     * @return OK
     */
    opportunityStatusGetAllForEstimate(): Observable<OpportunityStatusView[]>;
    /**
     * @return OK
     */
    opportunityStatusSearchManualStatus(isNew: boolean): Observable<OpportunityStatusView[]>;
    /**
     * @return OK
     */
    opportunityStatusGetNonQualifiedStatuses(): Observable<OpportunityStatusView[]>;
    /**
     * @return OK
     */
    opportunityStatusGetByIds(body: number[]): Observable<OpportunityStatusView[]>;
}

@Injectable({ providedIn: 'root' })
export class OpportunityStatusClient extends BaseClient implements IOpportunityStatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    opportunityStatusGetAll(): Observable<OpportunityStatusView[]> {
        let url_ = this.baseUrl + "/api/OpportunityStatus/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityStatusGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityStatusGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityStatusView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityStatusView[]>;
        }));
    }

    protected processOpportunityStatusGetAll(response: HttpResponseBase): Observable<OpportunityStatusView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityStatusView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityStatusGetAllForEstimate(): Observable<OpportunityStatusView[]> {
        let url_ = this.baseUrl + "/api/OpportunityStatus/estimate-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityStatusGetAllForEstimate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityStatusGetAllForEstimate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityStatusView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityStatusView[]>;
        }));
    }

    protected processOpportunityStatusGetAllForEstimate(response: HttpResponseBase): Observable<OpportunityStatusView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityStatusView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityStatusSearchManualStatus(isNew: boolean): Observable<OpportunityStatusView[]> {
        let url_ = this.baseUrl + "/api/OpportunityStatus/manual?";
        if (isNew === undefined || isNew === null)
            throw new globalThis.Error("The parameter 'isNew' must be defined and cannot be null.");
        else
            url_ += "isNew=" + encodeURIComponent("" + isNew) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityStatusSearchManualStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityStatusSearchManualStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityStatusView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityStatusView[]>;
        }));
    }

    protected processOpportunityStatusSearchManualStatus(response: HttpResponseBase): Observable<OpportunityStatusView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityStatusView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityStatusGetNonQualifiedStatuses(): Observable<OpportunityStatusView[]> {
        let url_ = this.baseUrl + "/api/OpportunityStatus/non-qualified";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityStatusGetNonQualifiedStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityStatusGetNonQualifiedStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityStatusView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityStatusView[]>;
        }));
    }

    protected processOpportunityStatusGetNonQualifiedStatuses(response: HttpResponseBase): Observable<OpportunityStatusView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityStatusView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityStatusGetByIds(body: number[]): Observable<OpportunityStatusView[]> {
        let url_ = this.baseUrl + "/api/OpportunityStatus/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityStatusGetByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityStatusGetByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityStatusView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityStatusView[]>;
        }));
    }

    protected processOpportunityStatusGetByIds(response: HttpResponseBase): Observable<OpportunityStatusView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityStatusView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOpportunityUserClient {
    /**
     * @return OK
     */
    opportunityUserSearchForOpportunity(body: SearchUsersForOpportunityParameters): Observable<OpportunityUserViewPaginatedResultDto>;
    /**
     * @return OK
     */
    opportunityUserDelete(id: number): Observable<void>;
    /**
     * @return OK
     */
    opportunityUserSearchAvailable(body: SearchAvailableOpportunityUsersParameters): Observable<UserView[]>;
}

@Injectable({ providedIn: 'root' })
export class OpportunityUserClient extends BaseClient implements IOpportunityUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    opportunityUserSearchForOpportunity(body: SearchUsersForOpportunityParameters): Observable<OpportunityUserViewPaginatedResultDto> {
        let url_ = this.baseUrl + "/api/OpportunityUser/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityUserSearchForOpportunity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityUserSearchForOpportunity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OpportunityUserViewPaginatedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OpportunityUserViewPaginatedResultDto>;
        }));
    }

    protected processOpportunityUserSearchForOpportunity(response: HttpResponseBase): Observable<OpportunityUserViewPaginatedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpportunityUserViewPaginatedResultDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityUserDelete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/OpportunityUser/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityUserDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityUserDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOpportunityUserDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    opportunityUserSearchAvailable(body: SearchAvailableOpportunityUsersParameters): Observable<UserView[]> {
        let url_ = this.baseUrl + "/api/OpportunityUser/search-available-opportunity-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpportunityUserSearchAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpportunityUserSearchAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserView[]>;
        }));
    }

    protected processOpportunityUserSearchAvailable(response: HttpResponseBase): Observable<UserView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IOrganizationClient {
    /**
     * @return OK
     */
    organizationGetById(id: number): Observable<OrganizationView>;
}

@Injectable({ providedIn: 'root' })
export class OrganizationClient extends BaseClient implements IOrganizationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    organizationGetById(id: number): Observable<OrganizationView> {
        let url_ = this.baseUrl + "/api/Organization/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrganizationGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrganizationGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationView>;
        }));
    }

    protected processOrganizationGetById(response: HttpResponseBase): Observable<OrganizationView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganizationView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProductTypeClient {
    /**
     * @return OK
     */
    productTypeGetById(id: number): Observable<ProductTypeView>;
    /**
     * @return OK
     */
    productTypeGetByIds(ids: number[]): Observable<ProductTypeView[]>;
    /**
     * @return OK
     */
    productTypeSave(body: ProductTypeView[]): Observable<ProductTypeView[]>;
    /**
     * @return OK
     */
    productTypeSearchProductTypes(body: SearchProductTypesParameters): Observable<ProductTypeView[]>;
    /**
     * @return OK
     */
    productTypeActivate(id: number): Observable<void>;
    /**
     * @return OK
     */
    productTypeDeactivate(id: number): Observable<void>;
}

@Injectable({ providedIn: 'root' })
export class ProductTypeClient extends BaseClient implements IProductTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    productTypeGetById(id: number): Observable<ProductTypeView> {
        let url_ = this.baseUrl + "/api/ProductType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductTypeGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductTypeGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductTypeView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductTypeView>;
        }));
    }

    protected processProductTypeGetById(response: HttpResponseBase): Observable<ProductTypeView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductTypeView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    productTypeGetByIds(ids: number[]): Observable<ProductTypeView[]> {
        let url_ = this.baseUrl + "/api/ProductType/get-by-ids?";
        if (ids === undefined || ids === null)
            throw new globalThis.Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductTypeGetByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductTypeGetByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductTypeView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductTypeView[]>;
        }));
    }

    protected processProductTypeGetByIds(response: HttpResponseBase): Observable<ProductTypeView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductTypeView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    productTypeSave(body: ProductTypeView[]): Observable<ProductTypeView[]> {
        let url_ = this.baseUrl + "/api/ProductType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductTypeSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductTypeSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductTypeView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductTypeView[]>;
        }));
    }

    protected processProductTypeSave(response: HttpResponseBase): Observable<ProductTypeView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductTypeView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    productTypeSearchProductTypes(body: SearchProductTypesParameters): Observable<ProductTypeView[]> {
        let url_ = this.baseUrl + "/api/ProductType/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductTypeSearchProductTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductTypeSearchProductTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductTypeView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductTypeView[]>;
        }));
    }

    protected processProductTypeSearchProductTypes(response: HttpResponseBase): Observable<ProductTypeView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductTypeView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    productTypeActivate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ProductType/activate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductTypeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductTypeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProductTypeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    productTypeDeactivate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ProductType/deactivate/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductTypeDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductTypeDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProductTypeDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStateClient {
    /**
     * @return OK
     */
    stateGetById(id: number): Observable<StateView>;
    /**
     * @return OK
     */
    stateSearch(body: SearchStateParameters): Observable<StateView[]>;
}

@Injectable({ providedIn: 'root' })
export class StateClient extends BaseClient implements IStateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    stateGetById(id: number): Observable<StateView> {
        let url_ = this.baseUrl + "/api/State/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStateGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStateGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StateView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StateView>;
        }));
    }

    protected processStateGetById(response: HttpResponseBase): Observable<StateView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StateView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    stateSearch(body: SearchStateParameters): Observable<StateView[]> {
        let url_ = this.baseUrl + "/api/State/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStateSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStateSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StateView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StateView[]>;
        }));
    }

    protected processStateSearch(response: HttpResponseBase): Observable<StateView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StateView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITagClient {
    /**
     * @return OK
     */
    tagSearch(body: SearchTagsParameters): Observable<TagView[]>;
    /**
     * @return OK
     */
    tagSave(body: TagView): Observable<TagView>;
}

@Injectable({ providedIn: 'root' })
export class TagClient extends BaseClient implements ITagClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    tagSearch(body: SearchTagsParameters): Observable<TagView[]> {
        let url_ = this.baseUrl + "/api/Tag/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTagSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTagSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TagView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TagView[]>;
        }));
    }

    protected processTagSearch(response: HttpResponseBase): Observable<TagView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TagView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    tagSave(body: TagView): Observable<TagView> {
        let url_ = this.baseUrl + "/api/Tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTagSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTagSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TagView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TagView>;
        }));
    }

    protected processTagSave(response: HttpResponseBase): Observable<TagView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TagView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserClient {
    /**
     * @return OK
     */
    userIsLoggedIn(): Observable<boolean>;
    /**
     * @return OK
     */
    userGetAuthenticatedUser(): Observable<UserView>;
    /**
     * @return OK
     */
    userGetApplications(): Observable<ApplicationInfoDto[]>;
    /**
     * @return OK
     */
    userGetByExternalId(id: number): Observable<UserView>;
    /**
     * @return OK
     */
    userSearch(body: SearchUsersParameters): Observable<UserView[]>;
    /**
     * @return OK
     */
    userUpdatePersonalInformation(body: UserPersonalInformationDto): Observable<void>;
    /**
     * @return OK
     */
    userGetPersonalInformation(): Observable<UserPersonalInformationDto>;
    /**
     * @return OK
     */
    userChangeUserPassword(body: ChangePasswordDto): Observable<void>;
    /**
     * @return OK
     */
    userChangeUserEmail(body: ChangeUserEmailDto): Observable<void>;
    /**
     * @return OK
     */
    userActivate(externalId: number): Observable<void>;
    /**
     * @return OK
     */
    userDeactivate(externalId: number): Observable<void>;
}

@Injectable({ providedIn: 'root' })
export class UserClient extends BaseClient implements IUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    userIsLoggedIn(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/User/is-logged-in";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserIsLoggedIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserIsLoggedIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUserIsLoggedIn(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    userGetAuthenticatedUser(): Observable<UserView> {
        let url_ = this.baseUrl + "/api/User/authenticated-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserGetAuthenticatedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserGetAuthenticatedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserView>;
        }));
    }

    protected processUserGetAuthenticatedUser(response: HttpResponseBase): Observable<UserView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    userGetApplications(): Observable<ApplicationInfoDto[]> {
        let url_ = this.baseUrl + "/api/User/applications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserGetApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserGetApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationInfoDto[]>;
        }));
    }

    protected processUserGetApplications(response: HttpResponseBase): Observable<ApplicationInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationInfoDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    userGetByExternalId(id: number): Observable<UserView> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserGetByExternalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserGetByExternalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserView>;
        }));
    }

    protected processUserGetByExternalId(response: HttpResponseBase): Observable<UserView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    userSearch(body: SearchUsersParameters): Observable<UserView[]> {
        let url_ = this.baseUrl + "/api/User/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserView[]>;
        }));
    }

    protected processUserSearch(response: HttpResponseBase): Observable<UserView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    userUpdatePersonalInformation(body: UserPersonalInformationDto): Observable<void> {
        let url_ = this.baseUrl + "/api/User/personal-information";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserUpdatePersonalInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserUpdatePersonalInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserUpdatePersonalInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    userGetPersonalInformation(): Observable<UserPersonalInformationDto> {
        let url_ = this.baseUrl + "/api/User/personal-information";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserGetPersonalInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserGetPersonalInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPersonalInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPersonalInformationDto>;
        }));
    }

    protected processUserGetPersonalInformation(response: HttpResponseBase): Observable<UserPersonalInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserPersonalInformationDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    userChangeUserPassword(body: ChangePasswordDto): Observable<void> {
        let url_ = this.baseUrl + "/api/User/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserChangeUserPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserChangeUserPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserChangeUserPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    userChangeUserEmail(body: ChangeUserEmailDto): Observable<void> {
        let url_ = this.baseUrl + "/api/User/change-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserChangeUserEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserChangeUserEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserChangeUserEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    userActivate(externalId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/User/activate/{externalId}";
        if (externalId === undefined || externalId === null)
            throw new globalThis.Error("The parameter 'externalId' must be defined.");
        url_ = url_.replace("{externalId}", encodeURIComponent("" + externalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    userDeactivate(externalId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/User/deactivate/{externalId}";
        if (externalId === undefined || externalId === null)
            throw new globalThis.Error("The parameter 'externalId' must be defined.");
        url_ = url_.replace("{externalId}", encodeURIComponent("" + externalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserOrganizationClient {
    /**
     * @return OK
     */
    userOrganizationGetForCurrentUser(): Observable<UserOrganizationView[]>;
}

@Injectable({ providedIn: 'root' })
export class UserOrganizationClient extends BaseClient implements IUserOrganizationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    userOrganizationGetForCurrentUser(): Observable<UserOrganizationView[]> {
        let url_ = this.baseUrl + "/api/UserOrganization/user-organizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserOrganizationGetForCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserOrganizationGetForCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserOrganizationView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserOrganizationView[]>;
        }));
    }

    protected processUserOrganizationGetForCurrentUser(response: HttpResponseBase): Observable<UserOrganizationView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserOrganizationView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserRoleClient {
    /**
     * @return OK
     */
    userRoleGetAll(): Observable<UserRoleView[]>;
}

@Injectable({ providedIn: 'root' })
export class UserRoleClient extends BaseClient implements IUserRoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    userRoleGetAll(): Observable<UserRoleView[]> {
        let url_ = this.baseUrl + "/api/UserRole/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserRoleGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserRoleGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleView[]>;
        }));
    }

    protected processUserRoleGetAll(response: HttpResponseBase): Observable<UserRoleView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserRoleView[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IValidatorsClient {
    /**
     * @return OK
     */
    validatorsGetViewValidators(): Observable<{ [key: string]: { [key: string]: { [key: string]: any; }; }; }>;
}

@Injectable({ providedIn: 'root' })
export class ValidatorsClient extends BaseClient implements IValidatorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * @return OK
     */
    validatorsGetViewValidators(): Observable<{ [key: string]: { [key: string]: { [key: string]: any; }; }; }> {
        let url_ = this.baseUrl + "/api/Validators";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatorsGetViewValidators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatorsGetViewValidators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: { [key: string]: { [key: string]: any; }; }; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: { [key: string]: { [key: string]: any; }; }; }>;
        }));
    }

    protected processValidatorsGetViewValidators(response: HttpResponseBase): Observable<{ [key: string]: { [key: string]: { [key: string]: any; }; }; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: { [key: string]: { [key: string]: any; }; }; };
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface AccountMapResult {
    latitude: number;
    longitude: number;
    accounts: SearchAccountsMapResult[] | undefined;
}

export interface AccountMarketView {
    id: number;
    accountId: number;
    accountName: string | undefined;
    marketId: number;
    marketName: string | undefined;
}

export interface AccountProductTypeView {
    id: number;
    productTypeId: number;
    productTypeName: string | undefined;
    isActive: boolean | undefined;
}

export interface AccountTypeView {
    id: number;
    name: string | undefined;
}

export interface AccountView {
    id: number;
    organizationId: number | undefined;
    name: string | undefined;
    description: string | undefined;
    webSite: string | undefined;
    linkedin: string | undefined;
    organizationName: string | undefined;
    createdByUserId: number | undefined;
    accountTypeId: number | undefined;
    accountTypeName: string | undefined;
    markets: string | undefined;
    isActive: boolean;
    accountMarkets: AccountMarketView[] | undefined;
    accountProductTypes: AccountProductTypeView[] | undefined;
    companies: CompanyView[] | undefined;
    customFieldValues: EntityCustomFieldValueView[] | undefined;
    accountSalespersons: EntityTypeUserView[] | undefined;
}

export interface AccountViewPaginatedResultDto {
    pageInfo: PaginationInfo;
    results: AccountView[] | undefined;
}

export interface ActivityLogView {
    id: number;
    entityTypeId: number;
    entityTypeName: string | undefined;
    entityId: number;
    message: string | undefined;
    userId: number;
    userFullName: string | undefined;
    date: Date;
    userFirstName: string | undefined;
    userLastName: string | undefined;
    changes: string | undefined;
    parametersChanged: string[] | undefined;
    readonly changedProperties: EntityPropertyValueChangedDto[] | undefined;
}

export interface ActivityLogViewPaginatedResultDto {
    pageInfo: PaginationInfo;
    results: ActivityLogView[] | undefined;
}

export interface AddressView {
    id: number;
    line1: string | undefined;
    line2: string | undefined;
    addressType: number | undefined;
    zipCode: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    countryId: number;
    countryName: string | undefined;
    stateId: number;
    stateName: string | undefined;
    cityId: number;
    cityName: string | undefined;
    addressLines: string | undefined;
    fullAddress: string | undefined;
    stateCode: string | undefined;
    countryCode: string | undefined;
}

export interface ApplicationInfoDto {
    name: string | undefined;
    url: string | undefined;
}

export interface ArchiveEntityOptionView {
    id: number;
    name: string | undefined;
    value: boolean;
}

export interface BidCategoryView {
    id: number;
    name: string | undefined;
}

export interface BuildingAlternateNameView {
    id: number;
    buildingId: number;
    name: string | undefined;
}

export interface BuildingBuildingClassView {
    id: number;
    buildingId: number;
    buildingName: string | undefined;
    buildingClassId: number;
    buildingClassName: string | undefined;
}

export interface BuildingClassView {
    id: number;
    name: string | undefined;
    buildingBuildingClasses: BuildingBuildingClassView[] | undefined;
}

export interface BuildingContactRoleView {
    id: number;
    name: string | undefined;
}

export interface BuildingContactView {
    id: number;
    contactId: number;
    contactOrganizationId: number | undefined;
    contactFullName: string | undefined;
    email: string[] | undefined;
    phone: string[] | undefined;
    companyId: number | undefined;
    currentCompanyId: number | undefined;
    companyName: string | undefined;
    buildingId: number;
    buildingName: string | undefined;
    buildingAddressLines: string | undefined;
    buildingCityName: string | undefined;
    buildingStateName: string | undefined;
    buildingCountryName: string | undefined;
    buildingContactRoleId: number | undefined;
    buildingContactRoleName: string | undefined;
    currentCompanyName: string | undefined;
}

export interface BuildingContactViewPaginatedResultDto {
    pageInfo: PaginationInfo;
    results: BuildingContactView[] | undefined;
}

export interface BuildingMapResult {
    latitude: number;
    longitude: number;
    buildings: SearchBuildingsMapResult[] | undefined;
}

export interface BuildingProductTypeView {
    id: number;
    productTypeId: number;
    productTypeName: string | undefined;
    isActive: boolean | undefined;
}

export interface BuildingView {
    id: number;
    organizationId: number | undefined;
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    alternateName: string | undefined;
    website: string | undefined;
    numberOfFloors: number | undefined;
    size: number | undefined;
    floorSize: number | undefined;
    isActive: boolean;
    createdByUserId: number | undefined;
    materialId: number | undefined;
    materialName: string | undefined;
    addressId: number;
    line1: string | undefined;
    line2: string | undefined;
    zipCode: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    countryId: number | undefined;
    countryName: string | undefined;
    stateId: number | undefined;
    stateName: string | undefined;
    cityId: number | undefined;
    cityName: string | undefined;
    fullAddress: string | undefined;
    addressLines: string | undefined;
    organizationName: string | undefined;
    propertyManagerCompanyName: string | undefined;
    propertyManagerCompanyIsActive: boolean | undefined;
    propertyManagerCompanyId: number | undefined;
    propertyManagerContactId: number | undefined;
    propertyManagerContactName: string | undefined;
    stateCode: string | undefined;
    countryCode: string | undefined;
    addressType: number | undefined;
    buildingAlternateNames: BuildingAlternateNameView[] | undefined;
    buildingBuildingClasses: BuildingBuildingClassView[] | undefined;
    buildingContacts: BuildingContactView[] | undefined;
    buildingProductTypes: BuildingProductTypeView[] | undefined;
    companyBuildings: CompanyBuildingView[] | undefined;
    customFieldValues: EntityCustomFieldValueView[] | undefined;
    alternateNames: string[] | undefined;
    buildingSalespersons: EntityTypeUserView[] | undefined;
}

export interface BuildingViewPaginatedResultDto {
    pageInfo: PaginationInfo;
    results: BuildingView[] | undefined;
}

export interface ChangeOpportunityStatusResultDto {
    opportunityStatusId: number;
    opportunityStatusName: string | undefined;
    acumaticaBidUrl: string | undefined;
}

export interface ChangeOrderCostsView {
    changeOrderStatusId: number;
    opportunityId: number;
    total: number;
}

export interface ChangePasswordDto {
    currentPassword: string | undefined;
    newPassword: string | undefined;
    confirmNewPassword: string | undefined;
}

export interface ChangeUserEmailDto {
    email: string | undefined;
}

export interface CityView {
    id: number;
    name: string | undefined;
    stateId: number;
    stateName: string | undefined;
    countryId: number | undefined;
    countryName: string | undefined;
    addresses: AddressView[] | undefined;
}

export interface CompanyBuildingView {
    id: number;
    isMain: boolean;
    companyId: number;
    companyName: string | undefined;
    companyMarkets: string | undefined;
    companyTypeName: string | undefined;
    contactFullName: string | undefined;
    line2: string | undefined;
    line1: string | undefined;
    buildingId: number;
    buildingName: string | undefined;
    addressLines: string | undefined;
    zipCode: string | undefined;
    countryName: string | undefined;
    stateName: string | undefined;
    cityName: string | undefined;
}

export interface CompanyBuildingViewPaginatedResultDto {
    pageInfo: PaginationInfo;
    results: CompanyBuildingView[] | undefined;
}

export interface CompanyMapResult {
    latitude: number;
    longitude: number;
    companies: SearchCompaniesMapResult[] | undefined;
}

export interface CompanyMarketView {
    id: number;
    companyId: number;
    companyName: string | undefined;
    marketId: number;
    marketName: string | undefined;
}

export interface CompanyTypeView {
    id: number;
    name: string | undefined;
    companies: CompanyView[] | undefined;
}

export interface CompanyView {
    id: number;
    organizationId: number | undefined;
    name: string | undefined;
    description: string | undefined;
    abbreviation: string | undefined;
    line2: string | undefined;
    webSite: string | undefined;
    linkedin: string | undefined;
    accountId: number | undefined;
    accountName: string | undefined;
    accountIsActive: boolean | undefined;
    createdByUserId: number | undefined;
    companyTypeId: number | undefined;
    companyTypeName: string | undefined;
    buildingName: string | undefined;
    buildingIsActive: boolean | undefined;
    line1: string | undefined;
    addressLines: string | undefined;
    zipCode: string | undefined;
    countryId: number | undefined;
    countryName: string | undefined;
    countryCode: string | undefined;
    stateId: number | undefined;
    stateName: string | undefined;
    stateCode: string | undefined;
    cityId: number | undefined;
    cityName: string | undefined;
    fullAddress: string | undefined;
    markets: string | undefined;
    organizationName: string | undefined;
    contactFirstName: string | undefined;
    contactLastName: string | undefined;
    contactFullName: string | undefined;
    contactPhone: string[] | undefined;
    contactId: number | undefined;
    contactIsActive: boolean | undefined;
    mainOfficeId: number | undefined;
    isActive: boolean;
    buildingContacts: BuildingContactView[] | undefined;
    buildings: BuildingView[] | undefined;
    companyBuildings: CompanyBuildingView[] | undefined;
    companyMarkets: CompanyMarketView[] | undefined;
    contacts: ContactView[] | undefined;
    customFieldValues: EntityCustomFieldValueView[] | undefined;
    companySalespersons: EntityTypeUserView[] | undefined;
}

export interface CompanyViewPaginatedResultDto {
    pageInfo: PaginationInfo;
    results: CompanyView[] | undefined;
}

export interface ConfigurationEntry {
    key: string | undefined;
    value: string | undefined;
}

export interface ContactView {
    id: number;
    organizationId: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string[] | undefined;
    phone: string[] | undefined;
    linkedin: string | undefined;
    address: string[] | undefined;
    description: string | undefined;
    createdByUserId: number | undefined;
    companyId: number | undefined;
    companyName: string | undefined;
    companyIsActive: boolean | undefined;
    companyTypeId: number | undefined;
    companyTypeName: string | undefined;
    organizationName: string | undefined;
    position: string | undefined;
    isMain: boolean | undefined;
    fullName: string | undefined;
    isActive: boolean;
    buildingContacts: BuildingContactView[] | undefined;
    customFieldValues: EntityCustomFieldValueView[] | undefined;
}

export interface ContactViewPaginatedResultDto {
    pageInfo: PaginationInfo;
    results: ContactView[] | undefined;
}

export interface CountryView {
    id: number;
    name: string | undefined;
    iso: string | undefined;
    addresses: AddressView[] | undefined;
    states: StateView[] | undefined;
}

export interface CreateBaseEstimateParameters {
    opportunityId: number;
    templateId: number | undefined;
}

export interface CreateOpportunityEstimateDto {
    baseEstimateId: number;
    organizationId: number;
    name: string;
    estimateUsers: number[] | undefined;
    status: number;
    number: string | undefined;
    description: string | undefined;
    bidDue: Date | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
}

export interface CreateOpportunityEstimateResultDto {
    id: number;
}

export interface CreateOpportunityManualParameters {
    actualValue: number | undefined;
    actualGrossMargin: number | undefined;
    opportunityId: number;
    opportunityStatusId: number;
}

export interface CustomFieldTypeView {
    id: number;
    name: string | undefined;
    editor: string | undefined;
    entityTypeCustomFields: EntityTypeCustomFieldView[] | undefined;
}

export interface DashboardComparisonOptionView {
    id: number;
    readonly name: string | undefined;
    readonly description: string | undefined;
    readonly currentPeriodDescription: string | undefined;
    readonly previousPeriodDescription: string | undefined;
}

export interface DivisionView {
    id: number;
    organizationId: number | undefined;
    name: string | undefined;
    organizationName: string | undefined;
    order: number;
    isActive: boolean;
    isReserved: boolean | undefined;
}

export interface DomainValidationMessage {
    validationType: string | undefined;
    validationMessage: string | undefined;
}

export interface DomainValidationResult {
    readonly isValid: boolean;
    propertyName: string | undefined;
    readonly validationMessages: DomainValidationMessage[] | undefined;
}

export interface EditOpportunityView {
    potentialValue: number | undefined;
    proposedGrossMarginPercentage: number | undefined;
    name: string | undefined;
    dueDate: Date | undefined;
    expectedResponseDate: Date | undefined;
    opportunityProbabilityId: number | undefined;
    opportunityStatusId: number;
    divisionId: number | undefined;
    opportunitySalespersons: OpportunityUserView[];
}

export interface EntityCustomFieldValueView {
    id: number;
    organizationId: number | undefined;
    entityTypeId: number;
    entityTypeCustomFieldId: number;
    entityId: number;
    name: string | undefined;
    customFieldDescription: string | undefined;
    customFieldTypeId: number | undefined;
    entityTypeCustomFieldSectionId: number | undefined;
    editor: string | undefined;
    order: number | undefined;
    value: string | undefined;
    options: string[] | undefined;
    isReserved: boolean | undefined;
    readonly validations: ICustomFieldValueValidationDto[] | undefined;
    rawValue: any | undefined;
}

export interface EntityPropertyValueChangedDto {
    property: string;
    type: number | undefined;
    old: any | undefined;
    new: any | undefined;
    displayName: string | undefined;
}

export interface EntitySearchColumnDto {
    displayName: string;
    propertyName: string;
    isSortable: boolean;
    isFrozen: boolean;
}

export interface EntityTypeCounterDto {
    name: string | undefined;
    count: number;
}

export interface EntityTypeCustomFieldSectionView {
    id: number;
    entityTypeId: number;
    entityTypeName: string | undefined;
    name: string | undefined;
    isDefault: boolean;
    entityTypeCustomFields: EntityTypeCustomFieldView[] | undefined;
}

export interface EntityTypeCustomFieldView {
    id: number;
    organizationId: number | undefined;
    organizationName: string | undefined;
    entityTypeId: number;
    name: string | undefined;
    description: string | undefined;
    customFieldTypeId: number;
    customFieldTypeName: string | undefined;
    entityTypeCustomFieldSectionId: number | undefined;
    customFieldSectionName: string | undefined;
    editor: string | undefined;
    order: number;
    isReserved: boolean;
    isActive: boolean;
    options: string[] | undefined;
    entityCustomFieldValues: EntityCustomFieldValueView[] | undefined;
}

export interface EntityTypeUserView {
    id: number;
    userId: number;
    userFirstName: string | undefined;
    userLastName: string | undefined;
    userEmail: string | undefined;
    userExternalId: number | undefined;
    userFullName: string | undefined;
    isActive: boolean | undefined;
}

export interface EntityTypeView {
    id: number;
    name: string | undefined;
    alternativeName: string | undefined;
    description: string | undefined;
    hasCustomFields: boolean;
    activityLogs: ActivityLogView[] | undefined;
    entityCustomFieldValues: EntityCustomFieldValueView[] | undefined;
    entityTypeCustomFieldSections: EntityTypeCustomFieldSectionView[] | undefined;
    entityTypeCustomFields: EntityTypeCustomFieldView[] | undefined;
    entityTypeUsers: EntityTypeUserView[] | undefined;
    notes: NoteView[] | undefined;
    notifications: NotificationView[] | undefined;
    tags: TagView[] | undefined;
}

export interface EstimateTypeView {
    id: number;
    name: string | undefined;
    opportunityEstimates: OpportunityEstimateView[] | undefined;
}

export interface ForgotPasswordDto {
    email: string | undefined;
}

export interface GetChangeOrderCostsResult {
    changeOrderCosts: ChangeOrderCostsView[] | undefined;
    finalEstimateSellPrice: number | undefined;
}

export interface GetEntityCountersParameters {
    entityTypeId: number;
    entityId: number;
}

export interface GetOpportunityActualValuesResultDto {
    actualValue: number | undefined;
    actualGrossMarginAmount: number | undefined;
    actualGrossMarginPercentage: number | undefined;
}

export interface GetOpportunityStatsByPeriodParameters {
    divisionIds: number[] | undefined;
    salesPersonIds: number[] | undefined;
}

export interface GetOpportunityStatsByPeriodResult {
    opportunitiesAmount: number;
    opportunitiesCount: number;
    awardedAmount: number;
    bidAmount: number;
    totalAwardedCount: number;
    totalBidCount: number;
    finalChangeOrdersAmount: number;
    totalGrossMarginAmount: number;
    totalGrossMarginPercentage: number;
    awardedBidCount: number;
    awardedRate: number;
}

export interface GetOpportunityStatsByPeriodResultOpportunityTotalsResultDto {
    dashboardComparisonOptionView: DashboardComparisonOptionView;
    previousResult: GetOpportunityStatsByPeriodResult;
    currentResult: GetOpportunityStatsByPeriodResult;
}

export interface GetOpportunityTermResultDto {
    totalTerm: number | undefined;
    avgTotalTerm: number | undefined;
}

export interface ICustomFieldValueValidationDto {
    readonly type: string | undefined;
    apply: boolean;
    readonly args: any | undefined;
}

export interface LeadSourceView {
    id: number;
    organizationId: number | undefined;
    name: string | undefined;
    organizationName: string | undefined;
    externalId: string | undefined;
    opportunities: OpportunityView[] | undefined;
}

export interface LegalStatusView {
    id: number;
    name: string | undefined;
}

export interface LinkOpportunityEstimateDto {
    opportunityId: number;
    baseEstimateId: number;
}

export interface LoginDto {
    email: string | undefined;
    password: string | undefined;
    rememberUser: boolean | undefined;
}

export interface MapClientConfiguration {
    host: string | undefined;
    accessTokenCrm: string | undefined;
    markerInfo: string | undefined;
    searchPlacesDefaultLimit: number;
    defaultZoomLevel: number;
    defaultHeight: number;
    defaultWidth: number;
}

export interface MarketView {
    id: number;
    name: string | undefined;
}

export interface MaterialView {
    id: number;
    name: string | undefined;
    buildings: BuildingView[] | undefined;
}

export interface NoteUserView {
    id: number;
    noteId: number;
    userId: number;
    userFirstName: string | undefined;
    userLastName: string | undefined;
    userFullName: string | undefined;
    userEmail: string | undefined;
}

export interface NoteView {
    id: number;
    title: string | undefined;
    message: string | undefined;
    entityTypeId: number;
    entityId: number;
    creationDate: Date;
    modificationDate: Date | undefined;
    userId: number | undefined;
    userFirstName: string | undefined;
    userLastName: string | undefined;
    userEmail: string | undefined;
    noteUsers: NoteUserView[] | undefined;
    readonly noteKey: string | undefined;
    notificationTitle: string | undefined;
    organizationId: number | undefined;
}

export interface NoteViewPaginatedResultDto {
    pageInfo: PaginationInfo;
    results: NoteView[] | undefined;
}

export interface NotificationTypeUserConfigurationView {
    id: number;
    organizationId: number | undefined;
    notificationTypeId: number;
    notificationTypeName: string | undefined;
    userId: number;
    userEmail: string | undefined;
    includeInAppNotification: boolean;
    includeEmailNotification: boolean;
    opportunityStatusNotificationTypeUserConfigurations: OpportunityStatusNotificationTypeUserConfigurationView[] | undefined;
}

export interface NotificationView {
    id: number;
    organizationId: number | undefined;
    title: string | undefined;
    message: string | undefined;
    notificationTypeId: number;
    entityTypeId: number;
    entityId: number;
    creatorUserId: number;
    targetUserId: number;
    notificationDate: Date;
    isRead: boolean;
}

export interface NotificationViewPaginatedResultDto {
    pageInfo: PaginationInfo;
    results: NotificationView[] | undefined;
}

export interface OpportunityBidCategoryView {
    id: number;
    bidCategoryId: number;
    bidCategoryName: string | undefined;
}

export interface OpportunityBuildingContactRoleView {
    id: number;
    buildingContactRoleId: number;
    buildingContactRoleName: string | undefined;
}

export interface OpportunityBuildingView {
    id: number;
    opportunityName: string | undefined;
    buildingId: number;
    buildingName: string | undefined;
    isActive: boolean | undefined;
    line2: string | undefined;
    line1: string | undefined;
    addressLines: string | undefined;
    zipCode: string | undefined;
    countryName: string | undefined;
    stateName: string | undefined;
    cityName: string | undefined;
    isMain: boolean | undefined;
}

export interface OpportunityBuildingViewPaginatedResultDto {
    pageInfo: PaginationInfo;
    results: OpportunityBuildingView[] | undefined;
}

export interface OpportunityChangeOrderEstimateView {
    id: number;
    name: string | undefined;
    description: string | undefined;
    sellPrice: number | undefined;
    order: number;
    grossMarginPercentage: number | undefined;
    grossMarginAmount: number | undefined;
    clientChangeOrderNumber: string | undefined;
    changeOrderStatusId: number;
    changeOrderStatusName: string | undefined;
    changeOrderReferenceTypeId: number;
    changeOrderReferenceTypeName: string | undefined;
    opportunityId: number;
    opportunityName: string | undefined;
    opportunityOrganizationId: number | undefined;
    baseEstimateId: number | undefined;
    changeOrderId: number;
    bidStatusId: number | undefined;
    bidDate: Date | undefined;
    awardedDate: Date | undefined;
    creationDate: Date;
    modificationDate: Date | undefined;
    finalEstimateId: number;
    externalUrl: string | undefined;
}

export interface OpportunityChangeOrderEstimateViewPaginatedResultDto {
    pageInfo: PaginationInfo;
    results: OpportunityChangeOrderEstimateView[] | undefined;
}

export interface OpportunityCompanyRoleView {
    id: number;
    opportunityCompanyId: number;
    buildingContactRoleId: number;
    buildingContactRoleName: string | undefined;
}

export interface OpportunityCompanyView {
    id: number;
    opportunityName: string | undefined;
    companyId: number;
    companyName: string | undefined;
    companyRoleDescriptions: string | undefined;
    fullAddress: string | undefined;
    companyTypeName: string | undefined;
    markets: string | undefined;
    isActive: boolean | undefined;
    opportunityCompanyRoles: OpportunityCompanyRoleView[] | undefined;
}

export interface OpportunityCompanyViewPaginatedResultDto {
    pageInfo: PaginationInfo;
    results: OpportunityCompanyView[] | undefined;
}

export interface OpportunityContactBuildingContactRoleView {
    id: number;
    opportunityContactId: number;
    buildingContactRoleId: number;
    buildingContactRoleName: string | undefined;
}

export interface OpportunityContactView {
    id: number;
    contactId: number;
    companyId: number | undefined;
    currentCompanyId: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fullName: string | undefined;
    phone: string[] | undefined;
    lastContactDate: Date | undefined;
    followUpDate: Date | undefined;
    buildingContactRoleNames: string | undefined;
    buildingContactRolesCount: number | undefined;
    companyName: string | undefined;
    email: string[] | undefined;
    currentCompanyName: string | undefined;
    opportunityName: string | undefined;
    opportunityBaseEstimateId: number | undefined;
    isActive: boolean | undefined;
    opportunityContactBuildingContactRoles: OpportunityContactBuildingContactRoleView[] | undefined;
}

export interface OpportunityContactViewPaginatedResultDto {
    pageInfo: PaginationInfo;
    results: OpportunityContactView[] | undefined;
}

export interface OpportunityEstimateSummaryView {
    id: number;
    opportunityEstimateId: number;
    sellPrice: number | undefined;
    grossMarginAmount: number | undefined;
    grossMarginPercentage: number | undefined;
    directCostAmount: number | undefined;
    directCostPercentage: number | undefined;
    opportunityEstimateSummaryTypeId: number;
    opportunityEstimateSummaryTypeDescription: string | undefined;
}

export interface OpportunityEstimateView {
    id: number;
    name: string | undefined;
    order: number | undefined;
    opportunityId: number;
    opportunityName: string | undefined;
    opportunityOrganizationId: number | undefined;
    estimateId: number;
    baseEstimateId: number | undefined;
    estimateTypeId: number;
    estimateTypeName: string | undefined;
    description: string | undefined;
    sellPrice: number | undefined;
    grossMarginAmount: number | undefined;
    grossMarginPercentage: number | undefined;
    creationDate: Date;
    modificationDate: Date | undefined;
    isSelected: boolean;
    baseEstimateSellPrice: number | undefined;
    changeOrderTotalSellPrice: number | undefined;
    alternateTotalSellPrice: number | undefined;
    alternateEstimates: number[] | undefined;
    directCost: number | undefined;
    opportunityStatusId: number | undefined;
    opportunityStatusName: string | undefined;
    removedAt: Date | undefined;
    totalTerm: number | undefined;
    avgTotalTerm: number | undefined;
    externalUrl: string | undefined;
    acumaticaBidUrl: string | undefined;
    alternateEstimateViews: OpportunityEstimateView[] | undefined;
    baseEstimateView: OpportunityEstimateView;
    opportunityEstimateSummaries: OpportunityEstimateSummaryView[] | undefined;
}

export interface OpportunityEstimateViewPaginatedResultDto {
    pageInfo: PaginationInfo;
    results: OpportunityEstimateView[] | undefined;
}

export interface OpportunityManualView {
    id: number;
    actualValue: number | undefined;
    actualGrossMargin: number | undefined;
    actualGrossMarginAmount: number | undefined;
    opportunities: OpportunityView[] | undefined;
    opportunityStatusId: number;
    opportunityStatusName: string | undefined;
}

export interface OpportunityMapResult {
    latitude: number;
    longitude: number;
    opportunities: SearchOpportunitiesMapResult[] | undefined;
}

export interface OpportunityMarketView {
    id: number;
    marketId: number;
    marketName: string | undefined;
}

export interface OpportunityProbabilityView {
    id: number;
    name: string | undefined;
    probabilityValue: number;
    opportunities: OpportunityView[] | undefined;
}

export interface OpportunityProductTypeView {
    id: number;
    productTypeId: number;
    productTypeName: string | undefined;
    isActive: boolean | undefined;
}

export interface OpportunityStatusAvailableDto {
    statusId: number;
    statusName: string | undefined;
    canSwitch: boolean;
}

export interface OpportunityStatusHistoryView {
    id: number;
    opportunityId: number;
    fromStatusId: number;
    toStatusId: number;
    changedByUserId: number;
    changedDate: Date;
    reason: string | undefined;
    userFirstName: string | undefined;
    userLastName: string | undefined;
    fromStatusName: string | undefined;
    toStatusName: string | undefined;
}

export interface OpportunityStatusNotificationTypeUserConfigurationView {
    id: number;
    opportunityStatusId: number;
    opportunityStatusName: string | undefined;
    notificationTypeUserConfigurationId: number;
    includeInAppNotification: boolean;
    includeEmailNotification: boolean;
}

export interface OpportunityStatusView {
    id: number;
    organizationId: number | undefined;
    name: string | undefined;
    organizationName: string | undefined;
    opportunities: OpportunityView[] | undefined;
    opportunityStatusHistoryFromStatuses: OpportunityStatusHistoryView[] | undefined;
    opportunityStatusHistoryToStatuses: OpportunityStatusHistoryView[] | undefined;
}

export interface OpportunityTagView {
    id: number;
    tagId: number;
    tagName: string | undefined;
    entityTypeId: number | undefined;
}

export interface OpportunityUserFavoriteView {
    id: number;
    opportunityId: number;
    opportunityName: string | undefined;
    userId: number;
    userFirstName: string | undefined;
    userLastName: string | undefined;
}

export interface OpportunityUserUserRoleView {
    id: number;
    opportunityUserId: number;
    userRoleId: number;
    userRoleCode: string | undefined;
    userRoleDescription: string | undefined;
}

export interface OpportunityUserView {
    id: number;
    userId: number;
    commissionPercentage: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    userFullName: string | undefined;
    email: string | undefined;
    userRoleDescriptions: string | undefined;
    userExternalId: number | undefined;
    isActive: boolean | undefined;
    opportunityUserUserRoles: OpportunityUserUserRoleView[] | undefined;
}

export interface OpportunityUserViewPaginatedResultDto {
    pageInfo: PaginationInfo;
    results: OpportunityUserView[] | undefined;
}

export interface OpportunityView {
    id: number;
    organizationId: number | undefined;
    name: string | undefined;
    description: string | undefined;
    projectId: string | undefined;
    divisionId: number | undefined;
    dueDate: Date | undefined;
    expectedResponseDate: Date | undefined;
    projectStart: Date | undefined;
    projectEnd: Date | undefined;
    bidDate: Date | undefined;
    awardedDate: Date | undefined;
    actualValue: number | undefined;
    actualGrossMarginPercentage: number | undefined;
    actualGrossMarginAmount: number | undefined;
    potentialValue: number | undefined;
    proposedGrossMarginPercentage: number | undefined;
    proposedGrossMarginAmount: number | undefined;
    bidStatusId: number | undefined;
    opportunityStatusId: number;
    opportunityProbabilityId: number | undefined;
    companyId: number | undefined;
    buildingId: number | undefined;
    buildingAddressId: number | undefined;
    line2: string | undefined;
    leadSourceId: number | undefined;
    opportunityManualId: number | undefined;
    createdByUserId: number | undefined;
    isActive: boolean;
    organizationName: string | undefined;
    divisionName: string | undefined;
    divisionIsActive: boolean | undefined;
    opportunityStatusName: string | undefined;
    probabilityValue: number | undefined;
    probabilityName: string | undefined;
    companyName: string | undefined;
    companyCityName: string | undefined;
    companyCountryName: string | undefined;
    companyCountryCode: string | undefined;
    companyAddressLines: string | undefined;
    companyStateName: string | undefined;
    companyStateCode: string | undefined;
    companyZipCode: string | undefined;
    companyContactPhone: string[] | undefined;
    buildingName: string | undefined;
    buildingIsActive: boolean | undefined;
    buildingSize: number | undefined;
    buildingFloorSize: number | undefined;
    addressId: number | undefined;
    line1: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    zipCode: string | undefined;
    countryId: number | undefined;
    stateId: number | undefined;
    cityId: number | undefined;
    countryName: string | undefined;
    countryCode: string | undefined;
    stateName: string | undefined;
    stateCode: string | undefined;
    cityName: string | undefined;
    fullAddress: string | undefined;
    addressLines: string | undefined;
    baseEstimateId: number | undefined;
    salesUsers: string | undefined;
    salesUsersCount: number | undefined;
    leadSourceName: string | undefined;
    contactEmail: string[] | undefined;
    contactPhone: string[] | undefined;
    contactFullName: string | undefined;
    leadSourceExternalId: string | undefined;
    organizationCode: string | undefined;
    projectDuration: number | undefined;
    companyNames: string | undefined;
    companyRoleNames: string | undefined;
    potentialTermAverage: number | undefined;
    potentialNumberOfTerms: number | undefined;
    opportunityBidCategories: OpportunityBidCategoryView[] | undefined;
    opportunityBuildingContactRoles: OpportunityBuildingContactRoleView[] | undefined;
    opportunityBuildings: OpportunityBuildingView[] | undefined;
    opportunityChangeOrderEstimates: OpportunityChangeOrderEstimateView[] | undefined;
    opportunityCompanies: OpportunityCompanyView[] | undefined;
    opportunityContacts: OpportunityContactView[] | undefined;
    opportunityEstimates: OpportunityEstimateView[] | undefined;
    opportunityMarkets: OpportunityMarketView[] | undefined;
    opportunityProductTypes: OpportunityProductTypeView[] | undefined;
    opportunityStatusHistories: OpportunityStatusHistoryView[] | undefined;
    opportunityTags: OpportunityTagView[] | undefined;
    opportunityUserFavorites: OpportunityUserFavoriteView[] | undefined;
    opportunityUsers: OpportunityUserView[] | undefined;
    baseEstimateExternalUrl: string | undefined;
    acumaticaBidUrl: string | undefined;
    opportunitySalespersons: OpportunityUserView[] | undefined;
    customFieldValues: EntityCustomFieldValueView[] | undefined;
}

export interface OrganizationView {
    id: number;
    name: string | undefined;
    code: string | undefined;
    address: string | undefined;
    accounts: AccountView[] | undefined;
    buildingContactRoles: BuildingContactRoleView[] | undefined;
    buildings: BuildingView[] | undefined;
    companies: CompanyView[] | undefined;
    contacts: ContactView[] | undefined;
    divisions: DivisionView[] | undefined;
    entityCustomFieldValues: EntityCustomFieldValueView[] | undefined;
    entityTypeCustomFields: EntityTypeCustomFieldView[] | undefined;
    notificationTypeUserConfigurations: NotificationTypeUserConfigurationView[] | undefined;
    notifications: NotificationView[] | undefined;
    productTypes: ProductTypeView[] | undefined;
    tags: TagView[] | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    hasAcumaticaIntegration: boolean | undefined;
}

export interface PaginationInfo {
    itemsCount: number;
    totalPages: number;
    pageNumber: number;
}

export interface PatchOpportunityViewJsonPatchDocument {
    readonly operations: PatchOpportunityViewOperation[] | undefined;
}

export interface PatchOpportunityViewOperation {
    path: string | undefined;
    op: string | undefined;
    from: string | undefined;
    value: any | undefined;
}

export interface ProductTypeView {
    id: number;
    name: string | undefined;
    order: number;
    isActive: boolean;
    isReserved: boolean | undefined;
}

export interface QuickSearchAccountParameters {
    filterText: string | undefined;
    organizationId: number | undefined;
    isActive: boolean | undefined;
}

export interface QuickSearchBidCategoriesParameters {
    filterText: string | undefined;
    organizationId: number | undefined;
}

export interface QuickSearchBuildingParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    filterText: string | undefined;
    organizationId: number | undefined;
    isActive: boolean | undefined;
}

export interface QuickSearchCompaniesParameters {
    filterText: string | undefined;
    organizationId: number | undefined;
    isActive: boolean | undefined;
}

export interface QuickSearchContactsParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    filterText: string | undefined;
    organizationId: number | undefined;
    onlyMain: boolean | undefined;
    companyId: number | undefined;
    excludedCompanyId: number | undefined;
    allCompanies: boolean | undefined;
}

export interface ReserveEntityOptionView {
    id: number;
    name: string | undefined;
    value: boolean;
}

export interface SaveAccountParameters {
    id: number;
    accountId: number;
}

export interface SearchAccountParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    filterText: string | undefined;
    includeArchived: boolean | undefined;
    accountTypeId: number | undefined;
    marketId: number | undefined;
    organizationId: number | undefined;
    userId: number;
    salespersons: number[] | undefined;
}

export interface SearchAccountsMapParameters {
    filterText: string | undefined;
    accountTypeId: number | undefined;
    marketId: number | undefined;
    includeArchived: boolean | undefined;
    organizationId: number | undefined;
    salespersons: number[] | undefined;
    latitudeFrom: number;
    latitudeTo: number;
    longitudeFrom: number;
    longitudeTo: number;
}

export interface SearchAccountsMapResult {
    id: number;
    name: string | undefined;
    accountTypeName: string | undefined;
    markets: string | undefined;
    productTypes: string | undefined;
    salesPersons: EntityTypeUserView[] | undefined;
}

export interface SearchActivityLogsParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    entityTypeId: number;
    entityId: number;
    userId: number | undefined;
    dateFrom: Date | undefined;
    dateTo: Date | undefined;
    filterText: string | undefined;
}

export interface SearchAvailableAccountCompaniesParameters {
    filterText: string | undefined;
    organizationId: number | undefined;
}

export interface SearchAvailableBaseEstimatesParameters {
    filterText: string | undefined;
}

export interface SearchAvailableBuildingCompaniesParameters {
    filterText: string | undefined;
    organizationId: number | undefined;
    buildingId: number;
}

export interface SearchAvailableBuildingContactsParameters {
    filterText: string | undefined;
    organizationId: number | undefined;
    buildingId: number;
}

export interface SearchAvailableCompanyBuildingsParameters {
    filterText: string | undefined;
    organizationId: number | undefined;
    companyId: number;
}

export interface SearchAvailableContactBuildingsParameters {
    filterText: string | undefined;
    organizationId: number | undefined;
    contactId: number;
}

export interface SearchAvailableOpportunityBuildingsParameters {
    filterText: string | undefined;
    organizationId: number | undefined;
    opportunityId: number;
}

export interface SearchAvailableOpportunityCompaniesParameters {
    filterText: string | undefined;
    organizationId: number | undefined;
    opportunityId: number;
}

export interface SearchAvailableOpportunityContactsParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    filterText: string | undefined;
    organizationId: number | undefined;
    onlyMain: boolean | undefined;
    companyId: number | undefined;
    excludedCompanyId: number | undefined;
    allCompanies: boolean | undefined;
    opportunityId: number;
}

export interface SearchAvailableOpportunityUsersParameters {
    filterText: string | undefined;
    organizationId: number | undefined;
    roleIds: number[] | undefined;
    excludedUsers: number[] | undefined;
    excludeLoggedUser: boolean | undefined;
    isActive: boolean | undefined;
    opportunityId: number;
}

export interface SearchBaseEstimateResultDto {
    id: number;
    name: string | undefined;
    opportunityId: number | undefined;
    canLinked: boolean;
}

export interface SearchBuildingsForAccountParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    accountId: number;
    organizationId: number | undefined;
}

export interface SearchBuildingsForCompanyParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    companyId: number;
    organizationId: number | undefined;
}

export interface SearchBuildingsForContactParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    contactId: number;
    organizationId: number | undefined;
}

export interface SearchBuildingsForOpportunityParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    filterText: string | undefined;
    opportunityId: number;
}

export interface SearchBuildingsMapParameters {
    filterText: string | undefined;
    countryId: number | undefined;
    stateId: number | undefined;
    cityId: number | undefined;
    organizationId: number | undefined;
    includeArchived: boolean | undefined;
    salespersons: number[] | undefined;
    latitudeFrom: number;
    latitudeTo: number;
    longitudeFrom: number;
    longitudeTo: number;
}

export interface SearchBuildingsMapResult {
    id: number;
    name: string | undefined;
    fullAddress: string | undefined;
    productTypes: string | undefined;
    alternateNames: string | undefined;
    salespersons: EntityTypeUserView[] | undefined;
    companyBuildingCount: number;
}

export interface SearchBuildingsParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    filterText: string | undefined;
    countryId: number | undefined;
    stateId: number | undefined;
    cityId: number | undefined;
    organizationId: number | undefined;
    propertyManagerCompanyId: number | undefined;
    includeArchived: boolean | undefined;
    salespersons: number[] | undefined;
}

export interface SearchCityParameters {
    filterText: string | undefined;
    countryId: number | undefined;
    stateId: number | undefined;
}

export interface SearchCompaniesForAccountParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    accountId: number;
    organizationId: number | undefined;
}

export interface SearchCompaniesForBuildingParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    buildingId: number;
    organizationId: number | undefined;
}

export interface SearchCompaniesForOpportunityParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    filterText: string | undefined;
    opportunityId: number;
}

export interface SearchCompaniesMapParameters {
    filterText: string | undefined;
    contactId: number | undefined;
    companyTypeId: number | undefined;
    marketId: number | undefined;
    organizationId: number | undefined;
    salespersons: number[] | undefined;
    includeArchived: boolean | undefined;
    latitudeFrom: number;
    latitudeTo: number;
    longitudeFrom: number;
    longitudeTo: number;
}

export interface SearchCompaniesMapResult {
    id: number;
    name: string | undefined;
    companyTypeName: string | undefined;
    buildingName: string | undefined;
    contactName: string | undefined;
    accountName: string | undefined;
    salespersons: EntityTypeUserView[] | undefined;
}

export interface SearchCompaniesParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    filterText: string | undefined;
    includeArchived: boolean | undefined;
    companyTypeId: number | undefined;
    contactId: number | undefined;
    marketId: number | undefined;
    organizationId: number | undefined;
    userId: number;
    salespersons: number[] | undefined;
}

export interface SearchContactsForAccountParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    accountId: number;
    organizationId: number | undefined;
}

export interface SearchContactsForBuildingParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    buildingId: number;
    organizationId: number | undefined;
}

export interface SearchContactsForCompanyParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    companyId: number;
    organizationId: number | undefined;
}

export interface SearchContactsForOpportunityParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    opportunityId: number;
    filterText: string | undefined;
}

export interface SearchContactsParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    filterText: string | undefined;
    includeArchived: boolean | undefined;
    companyId: number | undefined;
    organizationId: number | undefined;
}

export interface SearchCountryParameters {
    filterText: string | undefined;
}

export interface SearchDivisionsParameters {
    organizations: number[] | undefined;
    isActive: boolean | undefined;
    isReserved: boolean | undefined;
    divisionIds: number[] | undefined;
    filterText: string | undefined;
}

export interface SearchEntityTypeCustomFieldParameters {
    entityTypeId: number | undefined;
    organizationId: number | undefined;
    isActive: boolean | undefined;
    isReserved: boolean | undefined;
}

export interface SearchEstimateTemplatesParameters {
    filterText: string | undefined;
}

export interface SearchEstimateTemplatesResultDto {
    id: number;
    name: string | undefined;
    projectDescription: string | undefined;
}

export interface SearchMainEntitiesParameters {
    filterText: string | undefined;
    organizationId: number | undefined;
}

export interface SearchMainEntitiesResultDto {
    entityId: number;
    entityName: string | undefined;
    entityTypeId: number;
    entityTypeName: string | undefined;
}

export interface SearchNotesParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    entityTypeId: number;
    entityId: number;
    filterText: string | undefined;
    dateFrom: Date | undefined;
    dateTo: Date | undefined;
    noteUsers: number[] | undefined;
    createdByUserId: number | undefined;
}

export interface SearchNotificationsParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    targetUserId: number | undefined;
    organizationId: number | undefined;
    isRead: boolean | undefined;
}

export interface SearchOpportunitiesCalendarParameters {
    filterText: string | undefined;
    organizationId: number | undefined;
    userId: number | undefined;
    accountIds: number[] | undefined;
    companyIds: number[] | undefined;
    companyRoleIds: number[] | undefined;
    divisionIds: number[] | undefined;
    salespersonIds: number[] | undefined;
    opportunityStatusIds: number[] | undefined;
    proposedGrossMarginFrom: number | undefined;
    proposedGrossMarginTo: number | undefined;
    probabilityValueFrom: number | undefined;
    probabilityValueTo: number | undefined;
    potentialValueFrom: number | undefined;
    potentialValueTo: number | undefined;
    creationDateFrom: Date | undefined;
    creationDateTo: Date | undefined;
    dueDateFrom: Date;
    dueDateTo: Date;
    onlyFavorites: boolean | undefined;
    includeArchived: boolean | undefined;
    expectedResponseDateFrom: Date | undefined;
    expectedResponseDateTo: Date | undefined;
}

export interface SearchOpportunitiesCalendarResult {
    id: number;
    name: string | undefined;
    contactInfo: string | undefined;
    eventDate: Date;
    opportunityStatusName: string | undefined;
    companyName: string | undefined;
    opportunityValue: number | undefined;
    eventType: number;
    opportunityUsers: OpportunityUserView[] | undefined;
}

export interface SearchOpportunitiesMapParameters {
    filterText: string | undefined;
    organizationId: number | undefined;
    userId: number | undefined;
    accountIds: number[] | undefined;
    companyIds: number[] | undefined;
    divisionIds: number[] | undefined;
    companyRoleIds: number[] | undefined;
    salespersonIds: number[] | undefined;
    opportunityStatusIds: number[] | undefined;
    probabilityValueFrom: number | undefined;
    probabilityValueTo: number | undefined;
    proposedGrossMarginFrom: number | undefined;
    proposedGrossMarginTo: number | undefined;
    potentialValueFrom: number | undefined;
    potentialValueTo: number | undefined;
    onlyFavorites: boolean | undefined;
    dueDateFrom: Date | undefined;
    dueDateTo: Date | undefined;
    contactId: number | undefined;
    includeArchived: boolean | undefined;
    latitudeFrom: number;
    latitudeTo: number;
    longitudeFrom: number;
    longitudeTo: number;
    expectedResponseDateFrom: Date | undefined;
    expectedResponseDateTo: Date | undefined;
}

export interface SearchOpportunitiesMapResult {
    id: number;
    name: string | undefined;
    dueDate: Date | undefined;
    companyName: string | undefined;
    opportunityStatusName: string | undefined;
    potentialValue: number | undefined;
    opportunityUsers: OpportunityUserView[] | undefined;
}

export interface SearchOpportunitiesParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    filterText: string | undefined;
    organizationId: number | undefined;
    userId: number | undefined;
    accountIds: number[] | undefined;
    companyIds: number[] | undefined;
    companyRoleIds: number[] | undefined;
    divisionIds: number[] | undefined;
    buildingIds: number[] | undefined;
    salespersonIds: number[] | undefined;
    opportunityStatusIds: number[] | undefined;
    probabilityValueFrom: number | undefined;
    probabilityValueTo: number | undefined;
    proposedGrossMarginFrom: number | undefined;
    proposedGrossMarginTo: number | undefined;
    potentialValueFrom: number | undefined;
    potentialValueTo: number | undefined;
    contactId: number | undefined;
    includeArchived: boolean | undefined;
    onlyFavorites: boolean | undefined;
    dueDateFrom: Date | undefined;
    dueDateTo: Date | undefined;
    expectedResponseDateFrom: Date | undefined;
    expectedResponseDateTo: Date | undefined;
}

export interface SearchOpportunitiesResult {
    id: number;
    organizationId: number | undefined;
    name: string | undefined;
    description: string | undefined;
    projectId: string | undefined;
    divisionId: number | undefined;
    dueDate: Date | undefined;
    expectedResponseDate: Date | undefined;
    projectStart: Date | undefined;
    projectEnd: Date | undefined;
    bidDate: Date | undefined;
    awardedDate: Date | undefined;
    actualValue: number | undefined;
    actualGrossMarginPercentage: number | undefined;
    actualGrossMarginAmount: number | undefined;
    potentialValue: number | undefined;
    proposedGrossMarginPercentage: number | undefined;
    proposedGrossMarginAmount: number | undefined;
    bidStatusId: number | undefined;
    opportunityStatusId: number;
    opportunityProbabilityId: number | undefined;
    companyId: number | undefined;
    buildingId: number | undefined;
    buildingAddressId: number | undefined;
    line2: string | undefined;
    leadSourceId: number | undefined;
    opportunityManualId: number | undefined;
    createdByUserId: number | undefined;
    isActive: boolean;
    organizationName: string | undefined;
    divisionName: string | undefined;
    divisionIsActive: boolean | undefined;
    opportunityStatusName: string | undefined;
    probabilityValue: number | undefined;
    probabilityName: string | undefined;
    companyName: string | undefined;
    companyCityName: string | undefined;
    companyCountryName: string | undefined;
    companyCountryCode: string | undefined;
    companyAddressLines: string | undefined;
    companyStateName: string | undefined;
    companyStateCode: string | undefined;
    companyZipCode: string | undefined;
    companyContactPhone: string[] | undefined;
    buildingName: string | undefined;
    buildingIsActive: boolean | undefined;
    buildingSize: number | undefined;
    buildingFloorSize: number | undefined;
    addressId: number | undefined;
    line1: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    zipCode: string | undefined;
    countryId: number | undefined;
    stateId: number | undefined;
    cityId: number | undefined;
    countryName: string | undefined;
    countryCode: string | undefined;
    stateName: string | undefined;
    stateCode: string | undefined;
    cityName: string | undefined;
    fullAddress: string | undefined;
    addressLines: string | undefined;
    baseEstimateId: number | undefined;
    salesUsers: string | undefined;
    salesUsersCount: number | undefined;
    leadSourceName: string | undefined;
    contactEmail: string[] | undefined;
    contactPhone: string[] | undefined;
    contactFullName: string | undefined;
    leadSourceExternalId: string | undefined;
    organizationCode: string | undefined;
    projectDuration: number | undefined;
    companyNames: string | undefined;
    companyRoleNames: string | undefined;
    potentialTermAverage: number | undefined;
    potentialNumberOfTerms: number | undefined;
    opportunityBidCategories: OpportunityBidCategoryView[] | undefined;
    opportunityBuildingContactRoles: OpportunityBuildingContactRoleView[] | undefined;
    opportunityBuildings: OpportunityBuildingView[] | undefined;
    opportunityChangeOrderEstimates: OpportunityChangeOrderEstimateView[] | undefined;
    opportunityCompanies: OpportunityCompanyView[] | undefined;
    opportunityContacts: OpportunityContactView[] | undefined;
    opportunityEstimates: OpportunityEstimateView[] | undefined;
    opportunityMarkets: OpportunityMarketView[] | undefined;
    opportunityProductTypes: OpportunityProductTypeView[] | undefined;
    opportunityStatusHistories: OpportunityStatusHistoryView[] | undefined;
    opportunityTags: OpportunityTagView[] | undefined;
    opportunityUserFavorites: OpportunityUserFavoriteView[] | undefined;
    opportunityUsers: OpportunityUserView[] | undefined;
    baseEstimateExternalUrl: string | undefined;
    acumaticaBidUrl: string | undefined;
    opportunitySalespersons: OpportunityUserView[] | undefined;
    customFieldValues: EntityCustomFieldValueView[] | undefined;
    favoriteId: number | undefined;
    isFavorite: boolean;
    availableActions: number[] | undefined;
}

export interface SearchOpportunitiesResultPaginatedResultDto {
    pageInfo: PaginationInfo;
    results: SearchOpportunitiesResult[] | undefined;
}

export interface SearchOpportunityEstimateParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    opportunityId: number;
}

export interface SearchProductTypesParameters {
    filterText: string | undefined;
    organizationId: number | undefined;
    isActive: boolean | undefined;
    isReserved: boolean | undefined;
}

export interface SearchStateParameters {
    filterText: string | undefined;
    countryId: number | undefined;
}

export interface SearchTagsParameters {
    entityTypeId: number;
    filterText: string | undefined;
    organizationId: number | undefined;
}

export interface SearchUsersForOpportunityParameters {
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortDirection: string | undefined;
    pageNumber: number | undefined;
    opportunityId: number | undefined;
}

export interface SearchUsersParameters {
    filterText: string | undefined;
    organizationId: number | undefined;
    roleIds: number[] | undefined;
    excludedUsers: number[] | undefined;
    excludeLoggedUser: boolean | undefined;
    isActive: boolean | undefined;
}

export interface StateView {
    id: number;
    name: string | undefined;
    code: string | undefined;
    countryId: number;
    countryName: string | undefined;
    addresses: AddressView[] | undefined;
    cities: CityView[] | undefined;
}

export interface TagView {
    id: number;
    name: string | undefined;
    entityTypeId: number;
}

export interface TokenResultDto {
    token: string | undefined;
    expiresIn: number;
    isAuthorized: boolean;
    hasCaddieAccess: boolean;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    id: number;
    userOrganizations: UserOrganizationDto[] | undefined;
}

export interface UnlinkOpportunityEstimateResultDto {
    opportunityStatusId: number;
    opportunityStatusName: string | undefined;
    baseEstimateExternalUrl: string | undefined;
}

export interface UserOrganizationDto {
    userId: number;
    userFullName: string | undefined;
    userRoleId: number;
    userRoleCode: string | undefined;
    userRoleDescription: string | undefined;
    organizationId: number;
    organizationName: string | undefined;
    organizationCode: string | undefined;
    isAllowed: boolean;
}

export interface UserOrganizationView {
    id: number;
    userId: number;
    userFullName: string | undefined;
    userRoleId: number;
    userRoleCode: string | undefined;
    userRoleDescription: string | undefined;
    organizationId: number;
    organizationName: string | undefined;
    organizationCode: string | undefined;
    organizationImageUrl: string | undefined;
    hasAcumaticaIntegration: boolean | undefined;
}

export interface UserPersonalInformationDto {
    email: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    title: string | undefined;
}

export interface UserRoleView {
    id: number;
    code: string | undefined;
    description: string | undefined;
    userOrganizations: UserOrganizationView[] | undefined;
    users: UserView[] | undefined;
}

export interface UserView {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    userRoleId: number;
    userRoleCode: string | undefined;
    userRoleDescription: string | undefined;
    fullName: string | undefined;
    isActive: boolean;
    externalId: number | undefined;
    inverseCreatedByUser: UserView[] | undefined;
    inverseModifiedByUser: UserView[] | undefined;
    userOrganizations: UserOrganizationView[] | undefined;
    readonly name: string | undefined;
}

export class ApiError extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiError = true;

    static isApiError(obj: any): obj is ApiError {
        return obj.isApiError === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiError(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}